export const ar = {
  auth: {
    signIn: "تسجيل الدخول",
    signUp: "التسجيل",
    welcomeTitle: "مرحباً بكم في إنشا",
    welcomeSubtitle: "قم بتسجيل الدخول للوصول إلى مشاريعك وطلباتك وخدماتك.",
    emailAddress: "عنوان البريد الإلكتروني",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    password: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور الخاصة بك",
    forgotPassword: "هل نسيت كلمة السر؟",
    emailRequired: "عنوان البريد الإلكتروني مطلوب",
    emailInvalid: "يرجى إدخال بريد إلكتروني صالح",
    emailIsInvalid: "البريد الإلكتروني غير صالح",
    passwordMinLength: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    loginFailed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    loginFailedCheckCredentials: "فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد الخاصة بك.",
    loginSuccessfulTitle: "تم تسجيل الدخول بنجاح",
    welcomeBack: "مرحبًا بعودتك!",
    signInButton: "تسجيل الدخول",
    newToInchaa: "جديد في إنشا؟",
    registerNow: "سجل الآن",
    incorrectPassword: "كلمة المرور غير صحيحة",
    termsAndPrivacy: "بتسجيل الدخول، فإنك توافق على شروط الخدمة وسياسة الخصوصية الخاصة بـ Inchaa.",
    supportEmail: "support@inchaa.com",
    help: "يساعد",
    // Building background text
    findTrustedProfessionals: "إنشاء - ابحث عن مقاولين ومهندسين ومستشارين موثوق بهم",
    letsBuild: "دعونا نبني!",
    recoverPasswordTitle: "استعادة كلمة المرور",
    recoverPasswordSubtitle: "أدخل البريد الإلكتروني الذي استخدمته للتسجيل. سنرسل إليك كلمة مرور لمرة واحدة (OTP) لإعادة تعيين كلمة المرور.",
    sendEmailButton: "إرسال البريد الإلكتروني",
    recoverPasswordHelp: "إذا كنت بحاجة إلى مزيد من المساعدة",
    contactUs: "تواصل معنا",
    backToSignIn: "العودة إلى تسجيل الدخول",
    goToSignIn: "الذهاب إلى تسجيل الدخول",
    showPassword: "إظهار كلمة المرور",
    hidePassword: "إخفاء كلمة المرور",
    recoverPasswordOtpSent: "قمنا بإرسال رسالة إلى بريدك الإلكتروني لإعادة تعيين كلمة المرور. يرجى التحقق من بريدك.",
    recoverPasswordOtpFailed: "تعذر إرسال البريد الإلكتروني الآن. يرجى المحاولة مرة أخرى لاحقًا.",
    success: "نجاح",
    error: "خطأ",
    submitted: "مقدم",
    verificationResubmitted: "تم إعادة تقديم التحقق للمراجعة من قبل المسؤول.",
    registrationFailedTitle: "فشل التسجيل",
    failedToRegister: "تعذر إكمال التسجيل. يرجى المحاولة مرة أخرى.",
    recoverPasswordOtpSubtitle: "تم إرسال كلمة مرور لمرة واحدة (OTP) إلى بريدك الإلكتروني المسجل.",
    recoverPasswordOtpRequired: "يرجى إدخال رمز OTP الكامل المكون من 6 أرقام.",
    recoverPasswordOtpInvalid: "رمز OTP غير صالح. يرجى المحاولة مرة أخرى.",
    recoverPasswordOtpVerified: "تم التحقق من رمز OTP بنجاح. يمكنك الآن إعادة تعيين كلمة المرور.",
    continue: "متابعة",
    backToForgotPassword: "العودة إلى نسيت كلمة المرور",
    recoverPasswordEmailSentTitle: "تحقق من بريدك الإلكتروني",
    recoverPasswordEmailSentDescription: "قمنا بإرسال رابط إعادة تعيين كلمة المرور إلى",
    recoverPasswordEmailSentNote: "إذا لم تجد البريد في صندوق الوارد، يرجى التحقق من مجلد الرسائل غير المرغوب فيها.",
    openEmailApp: "فتح تطبيق البريد",
    resendEmail: "إعادة إرسال البريد الإلكتروني",
    termsAndPrivacy: "بتسجيل الدخول، فإنك توافق على {terms} و {privacy}.",
    termsAndPrivacyText: "بتسجيل الدخول، فإنك توافق على",
    and: "و",
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    setNewPasswordTitle: "تعيين كلمة مرور جديدة",
    setNewPasswordSubtitle: "أنشئ كلمة مرور جديدة لحسابك.",
    currentPasswordLabel: "كلمة المرور الحالية",
    currentPasswordPlaceholder: "أدخل كلمة المرور الحالية",
    newPasswordLabel: "كلمة المرور الجديدة",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    passwordPlaceholder: "أنشئ كلمة مرور",
    confirmPasswordPlaceholder: "أكد كلمة المرور",
    passwordRequired: "كلمة المرور مطلوبة",
    passwordNotMatching: "كلمة المرور غير متطابقة",
    passwordRequirementsTitle: "متطلبات كلمة المرور",
    passwordRequirementLength: "يجب أن لا تقل عن 8 أحرف",
    passwordRequirementCase: "تتضمن أحرفاً كبيرة وصغيرة",
    passwordRequirementNumber: "تتضمن رقماً واحداً على الأقل",
    passwordRequirementSpecial: "تتضمن رمزاً خاصاً واحداً على الأقل",
    passwordDoesNotMeetRequirements: "كلمة المرور لا تلبي المتطلبات",
    resetPasswordButton: "إعادة تعيين كلمة المرور",
    passwordResetSuccessTitle: "تمت إعادة تعيين كلمة المرور بنجاح",
    passwordResetSuccessDescription: "تم تحديث كلمة المرور الخاصة بك بنجاح. يمكنك الآن تسجيل الدخول إلى حساب إنشا باستخدام كلمة المرور الجديدة.",
    backToSignInButton: "العودة إلى تسجيل الدخول",
    // Form text
    selectUserType: "اختر نوع المستخدم",
    createYourAccount: "إنشاء حسابك",
    createAnAccount: "إنشاء حساب",
    companyDetails: "تفاصيل الشركة",
    businessDetails: "تفاصيل الأعمال",
    security: "حماية",
    tellUsAboutYourCompany: "أخبرنا عن شركتك",
    tellUsAboutYourBusiness: "أخبرنا عن أعمالك",
    tellAboutYourCompany: "أخبرنا عن شركتك...",
    createSecurePassword: "إنشاء كلمة مرور آمنة لحسابك",
    confirmPassword: "تأكيد كلمة المرور",
    createPasswordPlaceholder: "إنشاء كلمة مرور",
    confirmPasswordPlaceholder: "تأكيد كلمة المرور الخاصة بك",
    approvalRequired: "الموافقة مطلوبة",
    approvalRequiredMessage: "سنقوم بفريقنا بمراجعة حسابك. ستتلقى إشعاراً عبر البريد الإلكتروني عند الموافقة.",
    createAccount: "إنشاء حساب",
    // Verification
    verify: "تأكيد",
    resendOtp: "إعادة إرسال OTP",
    sendOtp: "إرسال OTP",
    edit: "تعديل",
    otpSentToNumber: "تم إرسال كلمة المرور لمرة واحدة (OTP) إلى رقم هاتفك المحمول",
    otpSentToEmail: "تم إرسال كلمة المرور لمرة واحدة (OTP) إلى بريدك الإلكتروني",
    otpSentToNewNumber: "تم إرسال كلمة المرور لمرة واحدة (OTP) إلى رقم هاتفك المحمول الجديد",
    verifyAndUpdateNumber: "التحقق وتحديث الرقم",
    verifyYourAccount: "Verify Your Account",
    verifyYourEmailAddress: "تحقق من عنوان بريدك الإلكتروني",
    verifyYourMobileNumber: "تحقق من رقم هاتفك المحمول",
    verifyEmailId: "التحقق من البريد الإلكتروني",
    verifyMobileNumber: "التحقق من رقم الهاتف المحمول",
    verificationDescription: "Please complete verification to access your account",
    emailVerificationCode: "Email Verification Code",
    mobileVerificationCode: "Mobile Verification Code",
    enterSixDigitCode: "Enter 6-digit code",
    emailVerified: "Email Verified",
    mobileVerified: "Mobile Verified",
    resend: "Resend",
    sending: "Sending...",
    resendAvailableIn: "Resend available in",
    maxResendAttemptsReached: "Maximum resend attempts reached",
    pleaseEnterSixDigitEmail: "يرجى إدخال رمز تحقق البريد الإلكتروني المكوّن من 6 أرقام",
    pleaseEnterSixDigitMobile: "يرجى إدخال رمز تحقق رقم الهاتف المكوّن من 6 أرقام",
    verifyAccount: "Verify Account",
    verifying: "Verifying...",
    backToLogin: "العودة إلى تسجيل الدخول",
    contractor: "مقاول",
    engineer: "مهندس",
    consultant: "استشاري",
    supplier: "المورد",
    superAdmin: "مشرف عام",
    providingServices: "أقدم خدمات لأعمال البناء",
    suggestServices: "يمكنني اقتراح خدمات ومواد",
    supplyMaterials: "أورد المواد والمنتجات",
    helpForAuthorization: "يمكنني المساعدة في الحصول على الترخيص",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    copyright: "© ٢٠٢٥ إنشا. جميع الحقوق محفوظة. للدعم، راسلنا على",
    // Form labels and text
    profilePicture: "صورة الملف الشخصي",
    recommendedSize: "الحجم الموصى به: 200 × 200 بكسل",
    basicInformation: "معلومات اساسية",
    firstName: "الاسم الأول",
    firstNameRequired: "الاسم الأول مطلوب",
    firstNameLettersOnly: "يجب أن يحتوي الاسم الأول على أحرف فقط",
    lastName: "اسم العائلة",
    lastNameRequired: "اسم العائلة مطلوب",
    lastNameLettersOnly: "يجب أن يحتوي اسم العائلة على أحرف فقط",
    enterFirstName: "أدخل اسمك الأول",
    enterLastName: "أدخل اسمك الأخير",
    enterEmail: "أدخل بريدك الإلكتروني",
    phoneNumber: "رقم التليفون",
    mobileNumber: "رقم الهاتف المحمول",
    countryCodeRequired: "رمز الدولة مطلوب",
    countryCodeSelectRequired: "يرجى اختيار رمز الدولة",
    phoneNumberRequired: "رقم الهاتف مطلوب",
    phoneDigitsOnly: "يجب أن يحتوي رقم الهاتف على أرقام فقط",
    phoneLengthBetween: "يجب أن يكون رقم الهاتف بين {min} و {max} رقمًا",
    phoneNumberInvalidForCountry: "يرجى إدخال رقم {country} صالح",
    phoneNumberInvalidFormatForCountry: "يرجى إدخال رقم {country} بصيغة صحيحة",
    invalidPhoneNumberFormat: "صيغة رقم الهاتف غير صحيحة",
    myAccount: "حسابي",
    editPhoneNumber: "تعديل رقم الهاتف",
    newPhoneNumber: "رقم الهاتف الجديد",
    enterNewPhoneNumber: "أدخل رقم هاتفك الجديد لتحديث حسابك.",
    enterPhoneNumberPlaceholder: "أدخل رقم الهاتف",
    phoneVerificationInfo: "لحماية حسابك، سنتحقق من رقم الهاتف الجديد قبل حفظ التغييرات.",
    phoneUpdatedSuccessfully: "تم تحديث رقم هاتفك بنجاح.",
    emailOrPhoneNotAvailable: "البريد الإلكتروني أو رقم الهاتف غير متاح. يرجى التحقق والمحاولة مرة أخرى.",
    emailAlreadyRegistered: "هذا البريد الإلكتروني مسجل بالفعل. يرجى استخدام بريد إلكتروني آخر أو تسجيل الدخول.",
    phoneAlreadyRegistered: "رقم الهاتف هذا مسجل بالفعل. يرجى استخدام رقم آخر أو تسجيل الدخول.",
    unableToVerifyEmailOrPhone: "تعذر التحقق من البريد الإلكتروني/الهاتف. يرجى المحاولة مرة أخرى.",
    creatingAccount: "جاري إنشاء الحساب...",
    confirmPasswordRequired: "يرجى تأكيد كلمة المرور",
    instagramInvalidUsername: "يرجى إدخال اسم مستخدم إنستغرام صالح",
    instagramNoLeadingOrTrailingPeriod: "لا يمكن أن يبدأ اسم مستخدم إنستغرام بنقطة أو ينتهي بها",
    instagramMaxLength: "يجب ألا يزيد معرف إنستغرام عن {max} حرفًا",
    instagramEnterOnlyId: "أدخل معرف إنستغرام فقط",
    instagramAllowedChars: "يُسمح بالأحرف والأرقام والشرطة السفلية (_) والنقطة (.) فقط",
    instagramAllowedCharsRtl: "يُسمح بالأحرف (بما فيها العربية) والأرقام والشرطة السفلية (_) والنقطة (.) فقط",
    instagramNoConsecutivePeriods: "لا يمكن أن يحتوي على نقاط متتالية",
    instagramUrlsNotAllowed: "الروابط غير مسموحة. يرجى إدخال اسم مستخدم إنستغرام فقط",
    portfolioMaxFileSize: "يجب أن يكون حجم الملف أقل من {max} ميجابايت لكل ملف",
    fileSizeMustBeLessThan: "يجب أن يكون حجم الملف أقل من {max} ميجابايت",
    fileSizeExceedsLimit: "حجم الملف يتجاوز حد 10 ميجابايت. يرجى اختيار ملف أصغر.",
    invalidLicenseFileType: "نوع الملف غير صالح. يرجى تحميل ملفات JPEG أو PNG أو WebP أو PDF.",
    invalidFileType:"نوع الملف غير صالح.",
    pdfFilesOnly: "يرجى تحميل ملفات PDF فقط.",
    letsStartWithBasicInfo: "لنبدأ بمعلوماتك الأساسية",
    previous: "السابق",
    back: "رجوع",
    next: "التالي",
    // Company Details form
    companyLogo: "شعار الشركة",
    companyName: "اسم الشركة",
    enterCompanyName: "أدخل اسم شركتك",
    instagramIdLabel: "معرف إنستغرام / الاسم",
    instagramIdPlaceholder: "@اسم_الشركة أو اسم_الشركة",
    companyOverview: "نظرة عامة على الشركة",
    businessType: "نوع العمل",
    individual: "فرد",
    company: "شركة",
    profileImage: "صورة الملف الشخصي",
    about: "نبذة",
    aboutRequired: "النبذة مطلوبة",
    tellAboutYourself: "تحدث عن نفسك...",
    uploadProfileImage: "تحميل صورة الملف الشخصي",
    addHere: "أضف هنا",
    clickToAddOverview: "انقر فوق \"إضافة هنا\" لإنشاء نظرة عامة غنية بالنص حول شركتك وخبراتك وخدماتك",
    shareCompanyInsights: "شارك لمحة عن شركتك وخبراتك وخدماتك.",
    streetAddress: "عنوان الشارع",
    enterStreetAddress: "أدخل عنوان الشارع الخاص بك",
    country: "دولة",
    selectCountry: "اختر بلدا",
    city: "المدينة",
    stateProvince: "الولاية / المقاطعة",
    selectStateProvince: "اختر الولاية / المقاطعة",
    postalCode: "رمز بريدي",
    enterPostalCode: "أدخل الرمز البريدي الخاص بك",
    buildingFlatName: "اسم المبنى/الشقة",
    enterBuildingFlatName: "اسم المبنى/الشقة",
    area: "المنطقة",
    enterArea: "أدخل المنطقة",
    areaRequired: "المنطقة مطلوبة",
    cityRequired: "المدينة/الولاية مطلوبة",
    countryRequired: "البلد مطلوب",
    buildingFlatNameRequired: "اسم المبنى/الشقة مطلوب",
    postalCodeRequired: "الرمز البريدي مطلوب",
    companyNameRequired: "اسم الشركة مطلوب",
    companyOverviewRequired: "نظرة عامة على الشركة مطلوبة",
    invalidHexColorExample: "يرجى إدخال لون سداسي عشري مثل #FFFFFF",
    contractorTypeRequired: "اختر نوع المقاول على الأقل",
    consultantTypeRequired: "اختر نوع استشاري واحد على الأقل",
    subServiceRequired: "يرجى اختيار خدمة فرعية واحدة على الأقل",
    contractorTypeLabel: "نوع المقاول",
    verificationUpdateTitle: "تحديث التحقق وإعادة الإرسال",
    verificationUpdateSubtitle: "يرجى تحديث الحقول وإعادة الإرسال لمراجعة المسؤول.",
    rejectionSummary: "ملخص الرفض",
    rejected: "مرفوض",
    rejectedOn: "تم الرفض في",
    reason: "السبب",
    userType: "نوع المستخدم",
    resubmitForReview: "إعادة الإرسال للمراجعة",
    submitting: "جاري الإرسال...",
    addServices: "إضافة خدمات",
    // Country names
    unitedArabEmirates: "الإمارات العربية المتحدة",
    // UAE Emirates (States/Provinces)
    abuDhabi: "أبوظبي",
    dubai: "دبي",
    sharjah: "الشارقة",
    ajman: "عجمان",
    ummAlQuwain: "أم القويين",
    rasAlKhaimah: "رأس الخيمة",
    fujairah: "الفجيرة",
    // Business Details form
    contractorType: "النوع",
    consultantType: "النوع",
    engineerType: "النوع",
    supplierType: "النوع",
    type: "النوع",
    maincontractor: "المقاول الرئيسي",
    subcontractor: "المقاول الفرعي",
    mainContractorServices: "خدمات المقاول الرئيسي",
    mainContractorServicesDescription: "سيقوم المقاولون الرئيسيون بتنفيذ جميع الخدمات.",
    subContractorServices: "خدمات المقاول الفرعي",
    subContractorServicesDescription: "سيتولى المقاولون الفرعيون الخدمات المحددة.",
    consultantdesign:"التصميم - استشاري",
    designConsultant: "التصميم - استشاري",
    designConsultantDescription: "تقديم خدمات استشارات التصميم لمشاريع البناء",
    inspectionConsultant: "التفتيش - استشاري",
    inspectionConsultantDescription: "تقديم خدمات التفتيش وضمان الجودة لمشاريع البناء",
    quantificationConsultant: "القياس الكمي - استشاري",
    quantificationConsultantDescription: "تقديم خدمات مسح الكميات وتقدير التكاليف لمشاريع البناء",
    // Role translations
    mainContractorRole: "المقاول الرئيسي",
    subContractorRole: "المقاول الفرعي",
    engineerRole: "مهندس",
    contractorRole: "مقاول",
    consultantRole: "استشاري",
    servicesOffered: "الخدمات المقدمة",
    chooseServicesYouOffer: "اختر الخدمات التي تقدمها",
    subServices: "الخدمات الفرعية",
    portfolioPreviousProjects: "المحفظة / المشاريع السابقة",
    chooseFile: "اختر الملف",
    uploadUpTo10Files: "حمل حتى 10 ملفات (الصور، المستندات). الحد الأقصى 10 ميجابايت لكل ملف.",
    submitForApproval: "إرسال للموافقة",
    thankYouForRegistering: "شكراً لك على التسجيل في إنشاء!",
    registrationSuccessMessage: "رحلتك مع إنشاء تبدأ قريباً – سيقوم فريقنا بمراجعة طلبك خلال {hours} ساعة. ستتلقى إشعاراً عبر البريد الإلكتروني بمجرد الموافقة على حسابك.",
    within48Hours: "48",
    profileSubmittedForReview: "تم تقديم الملف الشخصي للمراجعة",
    yourProfileUnderReview: "ملفك الشخصي قيد المراجعة الآن.",
    notifyViaEmailApproval: "سنقوم بإخطارك عبر البريد الإلكتروني بمجرد الموافقة على حسابك ويمكنك البدء في استخدام منصتنا.",
    yearStarted: "سنة البدء",
    enterYearStarted: "على سبيل المثال، 2017",
    licenseNumber: "رقم الرخصة",
    enterLicenseNumber: "أدخل رقم الترخيص",
    licenseExpiryDate: "تاريخ انتهاء صلاحية الترخيص",
    enterExpiryDate: "أدخل تاريخ انتهاء الصلاحية",
    uploadLicenseDocument: "تحميل وثيقة الترخيص",
    uploadOneFile: "حمل ملفًا واحدًا (JPEG، PNG، WebP، PDF). الحد الأقصى 10 ميجابايت.",
    uploaded: "تم التحميل:",
    uploadFile: "تحميل الملف",
    uploadFiles: "تحميل الملفات",
    uploadLogo: "تحميل الشعار",
    noLogoUploaded: "لم يتم تحميل الشعار",
    companyLogoUnsupportedType: "نوع الملف غير مدعوم. يرجى تحميل PNG (موصى به)، JPG، JPEG، SVG، أو WebP.",
    companyLogoMaxSize: "يتجاوز الملف الحجم الأقصى. يرجى تحميل ملف أصغر من 5 ميجابايت.",
    companyLogoInvalidDimensions: "أبعاد الشعار غير صالحة. يجب أن تكون الصورة بين 320×320 و400×400 بكسل.",
    companyLogoInvalidRatio: "نسبة الشعار غير صالحة. يجب أن تكون الصورة مربعة (نسبة 1:1).",
    companyLogoCannotRender: "تعذر عرض الملف. يرجى تجربة ملف آخر.",
    profileImageUnsupportedType: "نوع الملف غير مدعوم. يرجى تحميل PNG (موصى به)، JPG، JPEG، SVG، أو WebP.",
    profileImageMaxSize: "يتجاوز الملف الحجم الأقصى. يرجى تحميل ملف أصغر من 5 ميجابايت.",
    profileImageInvalidDimensions: "أبعاد صورة الملف الشخصي غير صالحة. يجب أن تكون الصورة بين 320×320 و400×400 بكسل.",
    profileImageInvalidRatio: "نسبة صورة الملف الشخصي غير صالحة. يجب أن تكون الصورة مربعة (نسبة 1:1).",
    profileImageCannotRender: "تعذر عرض ملف صورة الملف الشخصي. يرجى تجربة ملف آخر.",
    companyLogoErrorTitle: "خطأ في شعار الشركة",
    companyLogoErrorMessage: "يرجى إصلاح خطأ شعار الشركة قبل الإرسال.",
    profileImageErrorTitle: "خطأ في صورة الملف الشخصي",
    profileImageErrorMessage: "يرجى إصلاح خطأ صورة الملف الشخصي قبل الإرسال.",
    companyOverviewMaxLength: "يجب ألا تتجاوز نظرة عامة على الشركة {max} حرفًا.",
    aboutMaxLength: "يجب ألا يتجاوز حقل \"نبذة\" {max} حرفًا.",
    backgroundColor: "لون الخلفية",
    supportedFormatSize: "التنسيق: يدعم جميع تنسيقات الصور؛ يُنصح بـ PNG\nالحجم والنسبة: 400×400 بكسل (الحد الأدنى 320×320 بكسل)، 1:1 (مربع)، الحد الأقصى 5 ميجابايت",
    selectLocation: "اختر الموقع",
    confirmLocation: "تأكيد الموقع",
    confirm: "تأكيد",
    cancel: "إلغاء",
    showingDefaultLocation: "عرض الموقع الافتراضي. اضغط على \"تحديد موقعي\" لاستخدام موقعك الحالي.",
    clearSearchToUseLocateMe: "امسح حقل البحث لاستخدام تحديد موقعي.",
    gettingCurrentLocation: "جارٍ الحصول على موقعك الحالي...",
    waitingForGPSFix: "في انتظار إصلاح GPS الدقيق… اضغط على \"تحديد موقعي\" إذا استغرق الأمر وقتًا طويلاً.",
    locateMe: "تحديد موقعي",
    locating: "جارٍ تحديد الموقع…",
    secureConnectionRequired: "مطلوب اتصال آمن",
    secureConnectionRequiredMessage: "هذا الخيار يعمل فقط عبر اتصال آمن (HTTPS). لحمايتك، يتوفر الوصول إلى الموقع فقط على المواقع الآمنة. يرجى استخدام البحث في الخريطة للعثور على موقعك، أو التواصل مع المسؤول لتفعيل HTTPS لهذا الموقع.",
    geolocationNotSupported: "تحديد الموقع غير مدعوم",
    geolocationNotSupportedMessage: "متصفحك لا يدعم تحديد الموقع.",
    invalidLocation: "موقع غير صالح",
    invalidLocationMessage: "تعذر الحصول على إحداثيات موقع صالحة.",
    locationError: "خطأ في الموقع",
    unableToGetCurrentLocation: "تعذر الحصول على موقعك الحالي.",
    locationPermissionDenied: "تم رفض إذن الموقع",
    locationAccessDeniedMessage: "تم رفض الوصول إلى الموقع. يرجى تفعيل أذونات الموقع في إعدادات المتصفح ثم المحاولة مرة أخرى.",
    locationInformationUnavailable: "معلومات الموقع غير متاحة. يرجى التحقق من إعدادات الموقع على جهازك.",
    locationRequestTimedOut: "انتهت مهلة طلب الموقع. يرجى التأكد من تفعيل الموقع على جهازك ثم المحاولة مرة أخرى.",
    locationRequired: "الموقع مطلوب",
    locationRequiredMessage: "يرجى اختيار موقع على الخريطة قبل التأكيد.",
    failedToFetchServices: "فشل تحميل الخدمات",
    failedToFetchServicesMessage: "تعذر تحميل الخدمات المتاحة. يرجى تحديث الصفحة أو المحاولة لاحقًا.",
    invalidVerificationCode: "رمز التحقق غير صحيح. يرجى المحاولة مرة أخرى.",
    location: "الموقع",
    searchLocation: "ابحث عن الموقع",
    addLocation: "إضافة موقع",
    preferredLocation: "الموقع المفضل",
    seeMore: "عرض المزيد",
    seeLess: "عرض أقل",
    verified: "تم التحقق",
    notSpecified: "غير محدد",
    save: "حفظ",
    companyInformation: "معلومات الشركة",
    personalInformation: "المعلومات الشخصية",
    companyLogo: "شعار الشركة",
    companyName: "اسم الشركة",
    companyOverview: "نظرة عامة على الشركة",
    contactPerson: "الشخص المسؤول",
    emailAddress: "عنوان البريد الإلكتروني",
    emailLoginInfo: "يمكن استخدام هذا لتسجيل الدخول إلى تطبيق إنشاء.",
    phoneNumber: "رقم الهاتف",
    phoneEditVerificationInfo: "لتعديل رقم هاتفك، يتطلب التحقق.",
    address: "العنوان",
    postalCodeLabel: "الرمز البريدي",
    companyPortfolio: "محفظة الشركة",
    portfolio: "المحفظة",
    state: "الولاية",
    city: "المدينة",
    loadingLocations: "جاري تحميل المواقع...",
    errorLoadingLocations: "خطأ في تحميل المواقع",
    noLocationsAvailable: "لا توجد مواقع متاحة",
    view: "عرض",
    saving: "جاري الحفظ...",
    licenseInformation: "معلومات الترخيص",
    inReview: "قيد المراجعة",
    approved: "موافق عليه",
    rejected: "مرفوض",
    pending: "قيد الانتظار",
    licenseSubmitted: "تم إرسال الترخيص!",
    licenseSubmittedDescription: "سيقوم فريق الإدارة لدينا بالتحقق من المعلومات وإشعارك عبر البريد الإلكتروني بمجرد اكتمال الموافقة.",
    resubmit: "إعادة الإرسال",
    licenseVerificationNotApproved: "لم تتم الموافقة على التحقق من الترخيص",
    licenseRejectionDescription: "لم نتمكن من الموافقة على إرسال الترخيص الخاص بك بسبب المعلومات المفقودة أو غير الصالحة. يرجى مراجعة السبب أدناه وإعادة إرسال التفاصيل المحدثة لاستعادة الوصول.",
    reason: "السبب",
    licenseExpiryWarning: "سينتهي الترخيص الخاص بك في",
    pleaseRenewBeforeExpiry: "يرجى التجديد قبل تاريخ انتهاء الصلاحية.",
    updateNow: "تحديث الآن",
    licenseExpiredContactSupport: "انتهت صلاحية رخصتك. يرجى التواصل مع الدعم لتجديد الرخصة.",
    licenseRejectedBannerMessage: "تم رفض رخصتك. يرجى التحديث وإعادة الإرسال.",
    licenseUnderReviewBannerMessage: "رخصتك قيد المراجعة. يرجى انتظار الموافقة.",
    licenseExpiringSoon: "ستنتهي صلاحية رخصتك قريبًا.",
    updateLicenseToAvoidRestriction: "حدّث رخصتك لتجنب تقييد الوصول مؤقتًا.",
    role: "الدور:",
    licenseNumberLabel: "رقم الترخيص:",
    licenseExpiry: "انتهاء الترخيص:",
    yearsInBusiness: "سنوات في العمل:",
    attachedDocument: "المستند المرفق",
    download: "تحميل",
    enterLicenseNumber: "أدخل رقم الترخيص",
    enterBusinessStartYear: "أدخل سنة بدء العمل (YYYY)",
    enterExpiryDate: "أدخل تاريخ انتهاء الصلاحية",
    updatePassword: "تحديث كلمة المرور",
    updating: "جاري التحديث...",
    deleteAccount: "حذف الحساب",
    confirmAndDelete: "تأكيد والحذف",
    sendingOTP: "جاري إرسال رمز التحقق...",
    resendOTP: "إعادة إرسال رمز التحقق",
    sending: "جاري الإرسال...",
    verifyAndContinue: "التحقق والمتابعة",
    verifying: "جاري التحقق...",
    deletingAccount: "جاري حذف الحساب...",
    createAnAccount: "إنشاء حساب",
    portfolioPastProjects: "المحفظة / المشاريع السابقة",
    companyAddress: "عنوان الشركة",
    addYourServices: "أضف خدماتك",
    addMaterialsYouSupply: "أضف المواد التي توردها",
    selectMaterialsYouSupply: "اختر المواد التي توردها",
    cantFindMaterialBrand: "لا تجد مادة أو علامة تجارية؟ يمكنك طلب إضافة مادة أو علامة جديدة من المسؤول في أي وقت من شاشة إعدادات الحساب.",
    cantFindMaterialBrandTitle: "لا تجد مادة أو علامة تجارية؟",
    cantFindMaterialBrandDesc: "يمكنك طلب إضافة مادة أو علامة جديدة من المسؤول في أي وقت من شاشة إعدادات الحساب.",
    subMaterials: "المواد الفرعية",
    subItemsMaterials: "العناصر الفرعية (المواد)",
    subCategories: "الفئات الفرعية",
    selectAtLeastOneMaterial: "يرجى اختيار فئة مادة واحدة على الأقل أو عنصر فرعي.",
    availableMaterials: "المواد المتاحة",
    availableMaterialsDescription: "اختر المواد التي يمكنك توريدها. مطلوب عنصر واحد على الأقل.",
    noMaterialsSelected: "لم يتم اختيار مواد",
    clickToAddOrManageMaterials: "انقر لإضافة المواد أو إدارتها",
    addMaterials: "إضافة مواد",
    manageMaterials: "إدارة المواد",
    itemsSelected: "تم اختيار {count} عنصر",
    itemsSelected_other: "تم اختيار {count} عناصر",
    noMaterialsAvailable: "لا توجد مواد متاحة",
    engineerServicesStep: "خدمات المهندس",
    engineerSelectServiceTypeLabel: "اختر نوع الخدمة",
    engineerSelectServiceType: "اختر نوع خدمة واحدًا على الأقل",
    inspection: "التفتيش",
    quantification: "القياس الكمي",
    engineerHourlyChargesLabel: "أدخل الرسوم بالساعة (درهم)",
    engineerHourlyChargesRequired: "الرسوم بالساعة مطلوبة",
    engineerHourlyChargesGreaterThanZero: "يجب أن يكون المبلغ أكبر من 0",
    socialInstagramUrlLabel: "رابط إنستغرام",
    engineerHourlyChargesInvalid: "أدخل مبلغًا صالحًا",
    engineerHourlyChargesMaxDigits: "الحد الأقصى 12 رقمًا مسموحًا",
    engineerSetAvailabilityLabel: "حدد توفرك للتفتيش",
    engineerAvailabilityDescription: "قم بتكوين جدولك الأسبوعي بفترات زمنية مدتها ساعتان من 9:00 صباحًا إلى 7:00 مساءً",
    engineerAvailabilityRequired: "اختر فترة زمنية واحدة على الأقل",
    engineerSelectTimeSlot: "اختر الفترة الزمنية",
    engineerSlotsSelected: "فترات محددة",
    engineerSlot9_11: "9 ص - 11 ص",
    engineerSlot11_1: "11 ص - 1 م",
    engineerSlot1_3: "1 م - 3 م",
    engineerSlot3_5: "3 م - 5 م",
    engineerSlot5_7: "5 م - 7 م",
    servicesOffering: "عروض الخدمات",
    servicesOfferingRequired: "اختر خدمة واحدة على الأقل",
    viewServices: "عرض {{count}} خدمات",
    viewFullListOfServices: "عرض القائمة الكاملة للخدمات ({{count}})",
    selectServices: "اختر الخدمات",
    services: "الخدمات",
    description: "الوصف",
    close: "إغلاق",
    daySunday: "الأحد",
    dayMonday: "الإثنين",
    dayTuesday: "الثلاثاء",
    dayWednesday: "الأربعاء",
    dayThursday: "الخميس",
    dayFriday: "الجمعة",
    daySaturday: "السبت",
    createPassword: "إنشاء كلمة المرور",
    step: "الخطوة",
    licenseSubmittedTitle: "تم إرسال الرخصة!",
    licenseSubmittedDescription: "تم إرسال تفاصيل الرخصة للمراجعة. سيقوم فريق الإدارة لدينا بالتحقق من المعلومات وإشعارك عبر البريد الإلكتروني بمجرد اكتمال الموافقة.",
    note: "ملاحظة",
    licenseReviewNote: "أثناء المراجعة، سيظل حسابك مقيدًا مؤقتًا.",
    accessTemporarilyRestricted: "الوصول مقيد مؤقتًا",
    licenseExpiredMessage: "انتهت صلاحية رخصة التجارة الخاصة بك. لحماية العملاء والحفاظ على امتثال المنصة، تم تقييد وصولك إلى Inchaa مؤقتًا.",
    updateLicenseDetailsMessage: "يرجى تحديث تفاصيل الرخصة الخاصة بك لاستعادة الوصول والظهور مرة أخرى في نتائج بحث العملاء.",
    updateLicense: "تحديث الرخصة",
    updateLicenseInformation: "تحديث معلومات الرخصة",
    updateLicenseDescription: "يرجى تقديم تفاصيل الرخصة المحدثة أدناه. بمجرد الإرسال، سيقوم فريق الإدارة لدينا بمراجعة والموافقة على معلوماتك.",
    yearStarted: "سنة البدء",
    licenseNumber: "رقم الرخصة",
    enterLicenseNumber: "أدخل رقم الرخصة",
    licenseExpiryDate: "تاريخ انتهاء الرخصة",
    enterExpiryDate: "أدخل تاريخ الانتهاء",
    uploadLicenseDocument: "تحميل مستند الرخصة",
    uploadFile: "تحميل الملف",
    submitForReview: "إرسال للمراجعة",
    yearStartedRequired: "سنة البدء مطلوبة",
    yearStartedInvalid: "يرجى إدخال سنة صالحة (1900 إلى {maxYear})",
    yearBetween: "يرجى إدخال سنة بين {min} و {max}",
    licenseNumberRequired: "رقم الرخصة مطلوب",
    licenseExpiryRequired: "تاريخ انتهاء الرخصة مطلوب",
    licenseExpiryMustBeFuture: "يجب أن يكون تاريخ انتهاء الرخصة تاريخاً مستقبلاً",
    invalidLicenseExpiryDate: "تاريخ انتهاء الرخصة غير صالح",
    licenseFileRequired: "مستند الرخصة مطلوب",
    licenseUploadFailed: "فشل تحميل الرخصة",
    licenseUploadFailedMessage: "فشل تحميل مستند الرخصة. يرجى المحاولة مرة أخرى.",
    updateLicenseFailed: "فشل التحديث",
    updateLicenseFailedMessage: "فشل تحديث معلومات الرخصة. يرجى المحاولة مرة أخرى.",
    pleaseEnterValidYear: "يرجى إدخال سنة صالحة بين {min} و {max}",
    pleaseEnterValidDate: "يرجى إدخال تاريخ صالح",
    yearFormatError: "يرجى إدخال سنة صالحة بتنسيق YYYY (مثل، 2010)",
    yearRangeError: "يرجى إدخال سنة صالحة بين {min} و {max}",
    licenseExpiryFutureOnly: "يجب أن يكون تاريخ انتهاء الرخصة تاريخًا مستقبليًا (لا يُسمح بالتواريخ الحالية أو السابقة)",
    licenseDocumentRequired: "مستند الرخصة مطلوب",
    uploadFailed: "فشل التحميل",
    uploadDocumentsFailed: "لم نتمكن من تحميل مستنداتك. يرجى المحاولة مرة أخرى.",
    fileUploadError: "خطأ في تحميل الملف",
    somethingWentWrong: "حدث خطأ ما",
    pleaseLoginAgain: "يرجى تسجيل الدخول مرة أخرى للمتابعة.",
    goToLogin: "الانتقال إلى تسجيل الدخول",
    onlyAllowedFileTypes: "يُسمح فقط بملفات JPEG و PNG و WebP و PDF.",
    byLoggingInYouAgree: "بتسجيل الدخول، فإنك توافق على",
    and: "و",
    allRightsReserved: "© 2025 إنشاء. جميع الحقوق محفوظة. للدعم،",
    submitting: "جاري الإرسال...",
    deleteAccountOtpSentToEmail: "لقد أرسلنا رمز التحقق المكون من 6 أرقام إلى بريدك الإلكتروني المسجل",
    deleteAccountOtpSentToMobile: "لقد أرسلنا رمز التحقق المكون من 6 أرقام إلى رقم هاتفك المحمول المسجل",
    deleteAccountOtpEnterCode: "أدخل الرمز أدناه لتأكيد أنك صاحب الحساب قبل الحذف.",
    needHelp: "تحتاج مساعدة؟",
    resendOtp: "إعادة إرسال رمز التحقق",
    deleteAccountWarningPermanent: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
    deleteAccountWarningDescription: "بمجرد حذف حسابك، سيتم حذف جميع بياناتك بشكل دائم من التطبيق، بما في ذلك:",
    deleteAccountWarningAccountData: "بيانات الحساب والهوية",
    deleteAccountWarningAccountDataDesc: "تفاصيل ملفك الشخصي، معلومات الاتصال، وأوراق اعتماد الحساب.",
    deleteAccountWarningMediaFiles: "الوسائط والملفات المرفوعة",
    deleteAccountWarningMediaFilesDesc: "صور الملف الشخصي، صور المشاريع، وأي ملفات قمت بمشاركتها.",
    deleteAccountWarningServiceHistory: "سجل الخدمات والمعاملات",
    deleteAccountWarningServiceHistoryDesc: "جميع عروض الأسعار، طلبات الخدمة، الإعلانات المنشورة، والسجلات ذات الصلة.",
    deleteAccountWarningMessages: "الرسائل والتفاعلات",
    deleteAccountWarningMessagesDesc: "جميع سجل المحادثات والتواصل مع المقاولين والمهندسين أو العملاء.",
    deleteAccountWarningPreferences: "التفضيلات والإعدادات المخصصة المحفوظة",
    deleteAccountWarningPreferencesDesc: "الإشارات المرجعية، عمليات البحث المحفوظة، والإعدادات المخصصة."
  },
  approvals: {
    userApprovalsManagement: "إدارة موافقات المستخدمين",
    reviewAndApproveSubtitle: "مراجعة والموافقة على تسجيلات المقاولين الجدد مع مواصفات الخدمة التفصيلية.",
    totalApprovals: "إجمالي الموافقات",
    pendingApprovals: "الموافقات المعلقة",
    allStatus: "جميع الحالات",
    pendingLabel: "قيد الانتظار",
    rejectedLabel: "مرفوض",
    allRoles: "جميع الأدوار",
    roles: "الأدوار",
    name: "الاسم",
    email: "البريد الإلكتروني",
    company: "الشركة",
    experience: "الخبرة",
    years: "سنوات",
    status: "الحالة",
    actions: "الإجراءات",
    role: "الدور",
    noRole: "لا يوجد دور",
    viewDetails: "عرض التفاصيل",
    rejectContractor: "رفض المقاول",
    rejectConfirmMessage: "هل أنت متأكد أنك تريد رفض {name}؟ يرجى تقديم سبب.",
    rejectionReason: "سبب الرفض",
    rejectionReasonPlaceholder: "يرجى تقديم سبب للرفض...",
    reject: "رفض",
    rejecting: "جاري الرفض...",
    errorLoadingApprovals: "خطأ في تحميل الموافقات",
    failedToLoadApprovals: "فشل تحميل الموافقات. يرجى المحاولة مرة أخرى.",
    tryAgain: "حاول مرة أخرى",
    pleaseProvideRejectionReason: "يرجى تقديم سبب الرفض.",
    failedToApproveContractor: "فشل في الموافقة على المقاول.",
    failedToRejectContractor: "فشل في رفض المقاول.",
    approvedSuccessMessage: "تمت الموافقة على {name} بنجاح.",
    rejectedSuccessMessage: "تم رفض {name}.",
    both: "كلاهما",
    inspectionEngineer: "مهندس التفتيش",
    quantificationEngineer: "مهندس القياس الكمي",
    inspectionAndQuantificationEngineer: "مهندس التفتيش والقياس الكمي",
    searchPlaceholder: "بحث بالاسم، البريد الإلكتروني، الشركة...",
    searchPlaceholderMinChars: "بحث بالاسم، البريد الإلكتروني، الشركة... (4 أحرف على الأقل)"
  },
  contractorsPage: {
    title: "إدارة المقاولين",
    subtitle: "عرض معلومات تفصيلية عن المقاولين وعروضهم وأدائهم وأنشطتهم.",
    totalContractors: "إجمالي المقاولين",
    contractorsList: "قائمة المقاولين",
    errorLoadingContractors: "خطأ في تحميل المقاولين",
    failedToLoadContractors: "فشل تحميل المقاولين. يرجى المحاولة مرة أخرى."
  },
  consultantsPage: {
    title: "إدارة المستشارين",
    subtitle: "عرض معلومات تفصيلية عن المستشارين وخدماتهم وأنشطتهم.",
    totalConsultants: "إجمالي المستشارين",
    consultantsList: "قائمة المستشارين",
    errorLoadingConsultants: "خطأ في تحميل المستشارين",
    failedToLoadConsultants: "فشل تحميل المستشارين. يرجى المحاولة مرة أخرى."
  },
  engineersPage: {
    title: "إدارة المهندسين",
    subtitle: "عرض معلومات تفصيلية عن المهندسين وخدمات الفحص والقياس والأداء والأنشطة.",
    totalEngineers: "إجمالي المهندسين",
    engineersList: "قائمة المهندسين",
    errorLoadingEngineers: "خطأ في تحميل المهندسين",
    failedToLoadEngineers: "فشل تحميل المهندسين. يرجى المحاولة مرة أخرى."
  },
  customersPage: {
    title: "إدارة العملاء",
    subtitle: "إدارة حسابات العملاء وطلبات عروض الأسعار الخاصة بهم مع تتبع وتحليلات شاملة.",
    totalCustomers: "إجمالي العملاء",
    customersList: "قائمة العملاء",
    errorLoadingCustomers: "خطأ في تحميل العملاء",
    failedToLoadCustomers: "فشل تحميل العملاء. يرجى المحاولة مرة أخرى.",
    searchPlaceholderMinChars: "بحث بالاسم، البريد الإلكتروني، الهاتف... (4 أحرف على الأقل)"
  },
  quotesBookingsPage: {
    title: "إدارة عروض الأسعار والحجوزات",
    subtitle: "إدارة جميع عروض الأسعار من المقاولين مع تتبع وتحليلات شاملة.",
    searchPlaceholderMinChars: "بحث عن المشاريع، العملاء، المقاولين... (4 أحرف على الأقل)",
    allQuotations: "كل عروض الأسعار",
    contractorQuotations: "عروض أسعار المقاول",
    consultantQuotations: "عروض أسعار المستشار",
    quotationsCount: "عروض الأسعار",
    contractorQuotationsDescription: "قائمة عروض الأسعار المقدمة من هذا المقاول",
    consultantQuotationsDescription: "قائمة عروض الأسعار المقدمة من هذا المستشار",
    engineerQuotations: "عروض أسعار المهندس",
    engineerQuotationsDescription: "قائمة عروض الأسعار لهذا المهندس",
    contractorNoQuotationsYet: "لم يقدم هذا المقاول أي عروض أسعار بعد.",
    consultantNoQuotationsYet: "لم يقدم هذا المستشار أي عروض أسعار بعد.",
    engineerNoQuotationsYet: "لا توجد عروض أسعار لهذا المهندس بعد.",
    noQuotationsFound: "لا توجد عروض أسعار",
    tryAdjustingSearchOrFilters: "جرّب تعديل البحث أو الفلاتر للعثور على المزيد من عروض الأسعار.",
    noQuotationsAvailableYet: "لا توجد عروض أسعار بعد.",
    loadMore: "تحميل المزيد",
    loading: "جارٍ التحميل...",
    loadingQuotations: "جارٍ تحميل عروض الأسعار...",
    tryAgain: "حاول مرة أخرى",
    noImage: "لا توجد صورة",
    untitledProject: "مشروع بدون عنوان",
    locationNotSpecified: "الموقع غير محدد",
    viewProjectDetails: "عرض تفاصيل المشروع",
    errorLoadingQuotations: "خطأ في تحميل عروض الأسعار",
    failedToLoadQuotations: "فشل تحميل عروض الأسعار. يرجى المحاولة مرة أخرى."
  },
  superadminAds: {
    title: "Ad Posts",
    loadingAds: "Loading ads...",
    failedToLoadAds: "Failed to load ads.",
    latest: "Latest",
    oldest: "Oldest",
    adsFound: "{loaded} / {total} Ads found",
    filterByStatus: "الحالة",
    allStatuses: "جميع الحالات",
    statusRequestChange: "طلب تعديل",
    statusActive: "نشط",
    statusPending: "قيد الانتظار",
    statusOnHold: "Hold"
  },
  contractorAds: {
    serviceType: "نوع الخدمة",
    location: "الموقع",
    searchServicesPlaceholder: "البحث عن الخدمات...",
    quotationStatusFilter: "حالة العرض",
    quotationStatusAll: "جميع الحالات",
    quotationStatusInprogress: "قيد التنفيذ",
    quotationStatusSubmitted: "مقدم",
    quotationStatusExpired: "منتهي",
    quotationStatusDeclined: "مرفوض",
    quotationStatusCustomerRejected: "مرفوض من العميل",
    quotationStatusCustomerAccepted: "مقبول من العميل"
  },
  offersPage: {
    title: "إدارة العروض",
    subtitle: "إدارة العروض المعروضة في الصفحة الرئيسية لتطبيق العميل",
    searchPlaceholder: "بحث بعنوان العرض...",
    offer: "عرض",
    offers: "عروض",
    addNewOffer: "إضافة عرض جديد",
    saveOfferOrder: "حفظ ترتيب العروض",
    saving: "جارٍ الحفظ...",
    loadingOffers: "جارٍ تحميل العروض...",
    noOffersFound: "لا توجد عروض",
    noOffersMatchFilters: "لا توجد عروض تطابق الفلاتر الحالية.",
    getStartedCreateOffer: "ابدأ بإنشاء عرض جديد.",
    order: "الترتيب",
    created: "تاريخ الإنشاء",
    updated: "آخر تحديث",
    untitled: "بدون عنوان",
    untitledOffer: "عرض بدون عنوان",
    offerNotFound: "لم يتم العثور على العرض",
    offerNotFoundMessage: "تعذر العثور على العرض الذي تحاول تعديله ضمن القائمة الحالية.",
    offerDeletedSuccessfully: "تم حذف العرض بنجاح",
    failedToDeleteOffer: "فشل حذف العرض",
    offerUpdatedSuccessfully: "تم تحديث العرض بنجاح",
    offerCreatedSuccessfully: "تم إنشاء العرض بنجاح",
    create: "إنشاء",
    update: "تحديث",
    failedToSaveOffer: "فشل {action} العرض",
    failedToUpdateOfferStatus: "فشل تحديث حالة العرض",
    activated: "تم تفعيله",
    deactivated: "تم تعطيله",
    offerStatusUpdatedSuccessfully: "تم {status} العرض بنجاح",
    failedToUpdateOfferOrder: "فشل تحديث ترتيب العروض",
    offerOrderSavedSuccessfully: "تم حفظ ترتيب العروض بنجاح",
    failedToSaveOfferOrder: "فشل حفظ ترتيب العروض",
    toggleStatusTo: "تبديل الحالة إلى {status}",
    moveUp: "تحريك للأعلى",
    moveDown: "تحريك للأسفل",
    moveEarlier: "تقديم",
    moveLater: "تأخير",
    edit: "تعديل",
    delete: "حذف",
    deleteOffer: "حذف العرض",
    thisOffer: "هذا العرض",
    deleteConfirm: "هل أنت متأكد أنك تريد حذف \"{title}\"؟ لا يمكن التراجع عن هذا الإجراء.",
    deleting: "جارٍ الحذف...",
    imageEn: "الصورة (EN)",
    imageAr: "الصورة (AR)",
    dragToReorder: "اسحب لإعادة الترتيب"
  },
  featuredProvidersPage: {
    title: "المزودون المميزون",
    subtitle: "إدارة مقدمي الخدمة المميزين وترتيب الأولوية الخاص بهم",
    searchPlaceholder: "ابحث عن مزودي الخدمة...",
    addProvider: "إضافة مقدم خدمة",
    addFirstProvider: "إضافة أول مقدم خدمة",
    saveProviders: "حفظ مقدمي الخدمة",
    saving: "جاري الحفظ...",
    saveProvidersTooltip: "حفظ جميع مقدمي الخدمة حسب ترتيب الأولوية",
    selectedProvidersCount: "تم تحديد {count} مقدم خدمة",
    removeSelected: "إزالة المحدد",
    refreshingProvidersList: "جارٍ تحديث قائمة مقدمي الخدمة...",
    loadingProviders: "جارٍ تحميل مقدمي الخدمة...",
    errorLoadingProviders: "خطأ في تحميل مقدمي الخدمة",
    noProvidersMatchSearch: "لا يوجد مقدمو خدمة يطابقون البحث",
    noFeaturedProvidersYet: "لا يوجد مقدمو خدمة مميزون بعد",
    remove: "إزالة",
    dragToReorder: "اسحب لإعادة الترتيب",
    pleaseSelectProvidersFirst: "يرجى تحديد مقدمي الخدمة أولاً",
    failedToRemoveProviders: "فشل في إزالة مقدمي الخدمة",
    failedToRemoveProvider: "فشل في إزالة مقدم الخدمة",
    failedToUpdateProviderOrder: "فشل في تحديث ترتيب مقدمي الخدمة",
    failedToUpdateProvidersList: "فشل في تحديث قائمة مقدمي الخدمة",
    allSelectedProvidersAlreadyAdded: "جميع مقدمي الخدمة المحددين مضافون بالفعل",
    failedToAddProviders: "فشل في إضافة مقدمي الخدمة",
    pleaseAddAtLeastOneProvider: "يرجى إضافة مقدم خدمة واحد على الأقل قبل الحفظ",
    providersSavedSuccessfully: "تم حفظ {count} مقدم خدمة بنجاح",
    failedToSaveFeaturedProviders: "فشل في حفظ مقدمي الخدمة المميزين",
    table: {
      priority: "الأولوية",
      providerName: "اسم مقدم الخدمة",
      companyName: "اسم الشركة",
      email: "البريد الإلكتروني",
      status: "الحالة",
      actions: "الإجراءات"
    }
  },
  featuredProvidersModal: {
    addFeatured: "إضافة {role} مميزين",
    searchProviders: "بحث عن مقدمي الخدمة",
    searchPlaceholder: "ابحث بالاسم أو البريد الإلكتروني أو الشركة...",
    loadingProviders: "جارٍ تحميل مقدمي الخدمة...",
    errorLoadingProviders: "خطأ في تحميل مقدمي الخدمة",
    noProvidersAvailable: "لا يوجد مقدمو خدمة متاحون",
    noProvidersMatchSearch: "لا يوجد مقدمو خدمة يطابقون معايير البحث",
    selectAllCount: "تحديد الكل ({count})",
    showingRange: "عرض {from} إلى {to} من أصل {total} مقدم خدمة",
    show: "عرض:",
    previous: "السابق",
    next: "التالي",
    pageOf: "الصفحة {page} من {totalPages}",
    applyChanges: "تطبيق التغييرات"
  },
  offerModal: {
    editPromotion: "تعديل العرض",
    addPromotion: "إضافة عرض",
    promotionTitle: "عنوان العرض",
    enterPromotionTitle: "أدخل عنوان العرض",
    promotionTitleRequired: "عنوان العرض مطلوب",
    promotionBannerImageEn: "صورة بانر العرض (إنجليزي)",
    promotionBannerImageAr: "صورة بانر العرض (عربي)",
    promotionBannerImageRequiredEn: "صورة بانر العرض (إنجليزي) مطلوبة",
    promotionBannerImageRequiredAr: "صورة بانر العرض (عربي) مطلوبة",
    dragDropOrUploadImage: "اسحب وأفلت أو قم بتحميل الصورة",
    imageRequirements: "(PNG/JPG، الحد الأدنى 440×226 بكسل، الحد الأقصى 2MB)",
    uploading: "جارٍ الرفع...",
    promotionLinkEn: "رابط العرض (إنجليزي)",
    promotionLinkAr: "رابط العرض (عربي)",
    promotionLinkRequired: "رابط العرض مطلوب",
    linkType: "نوع الرابط",
    inApp: "داخل التطبيق",
    web: "ويب",
    inAppLinkMustStartWith: "يجب أن يبدأ رابط داخل التطبيق بـ \"inchaa://\"",
    webLinkMustStartWith: "يجب أن يبدأ رابط الويب بـ http:// أو https://",
    activePromotionsWillAppear: "ستظهر العروض المفعّلة في تطبيق العميل",
    promotionCreatedInactiveByDefault: "سيتم إنشاء العرض كغير مفعّل افتراضيًا",
    saveAndContinue: "حفظ ومتابعة",
    onlyPngAndJpgAllowed: "يسمح فقط بصور PNG و JPG",
    fileSizeMustBeLessThan: "يجب أن يكون حجم الملف أقل من {size}"
  },
  licenseManagement: {
    title: "إدارة الرخص",
    subtitle: "إدارة إعادة تقديم الرخص ورفضها وانتهائها لمقدمي الخدمات.",
    errorLoading: "خطأ في تحميل إدارة الرخص",
    failedToLoad: "فشل تحميل بيانات إدارة الرخص. يرجى المحاولة مرة أخرى.",
    dataRefreshedSuccessfully: "تم تحديث البيانات بنجاح"
  },
  serviceProviderDetails: {
    consultantApprovalDetails: "تفاصيل موافقة الاستشاري",
    consultantDetails: "تفاصيل الاستشاري",
    contractorApprovalDetails: "تفاصيل موافقة المقاول",
    contractorDetails: "تفاصيل المقاول",
    reviewConsultantRegistration: "مراجعة تسجيل الاستشاري والموافقة أو الرفض",
    viewConsultantInformation: "عرض معلومات وتفاصيل الاستشاري",
    reviewContractorRegistration: "مراجعة تسجيل المقاول والموافقة أو الرفض",
    viewContractorInformation: "عرض معلومات وتفاصيل المقاول",
    errorLoadingDetails: "خطأ في تحميل تفاصيل مقدم الخدمة",
    failedToLoadDetails: "فشل تحميل تفاصيل مقدم الخدمة",
    serviceProviderNotFound: "لم يتم العثور على مقدم الخدمة",
    noInformationAvailable: "لا توجد معلومات متاحة",
    pageNoData: "لا توجد بيانات في هذه الصفحة. المعلومات لم تعد متاحة.",
    pageNoDataAccountDeleted: "لا توجد بيانات في هذه الصفحة. ربما تم حذف الحساب أو المعلومات لم تعد متاحة.",
    portfolioDocument: "مستند المعرض {number}",
    clickToView: "اضغط للعرض",
    serviceLocations: "مواقع الخدمة",
    noServiceLocationsAvailable: "لا توجد مواقع خدمة متاحة",
    servicesOfferedMainContractor: "الخدمات المقدمة (المقاول الرئيسي)",
    servicesOfferedSubContractor: "الخدمات المقدمة (المقاول الفرعي)",
    materialsList: "قائمة المواد",
    loadingServices: "جارٍ تحميل الخدمات...",
    noServicesAvailable: "لا توجد خدمات متاحة",
    portfolio: "المعرض",
    noPortfolioItemsAvailable: "لا توجد عناصر في المعرض",
    licenseDocument: "مستند الرخصة",
    noLicenseDocumentUploaded: "لم يتم تحميل مستند الرخصة",
    view: "عرض",
    accountStatus: "حالة الحساب",
    processing: "جارٍ المعالجة...",
    approveLicense: "قبول الرخصة",
    rejectLicense: "رفض الرخصة",
    licenseRejectedWithIcon: "✗ الرخصة مرفوضة",
    licenseExpired: "انتهت الرخصة",
    approvedAndActive: "مقبول ونشط",
    pendingApproval: "معلق للموافقة",
    deactivatedDescription: "هذا الحساب معطل مؤقتًا ومخفي عن العملاء. لا يمكن لـ{role} استقبال طلبات جديدة.",
    approvedDescription: "تمت الموافقة على {role} وهو نشط حاليًا. الملف مرئي للعملاء ويمكنه استقبال طلبات الخدمة.",
    rejectedDescription: "تم رفض حساب {role} بسبب معلومات غير مكتملة أو غير صحيحة. {role} غير مرئي للعملاء حاليًا.",
    pendingApprovalDescription: "قام {role} بإرسال تفاصيل الحساب والرخصة. يرجى مراجعة المعلومات للموافقة أو الرفض.",
    pendingApprovalInfo: "سيتم إدراج {role} المقبولين للعملاء. يمكن للحسابات المرفوضة إعادة إرسال تفاصيل محدثة.",
    reactivateAccount: "إعادة تفعيل الحساب",
    deactivateAccount: "تعطيل الحساب",
    reactivateGuidance: "أعد تفعيل الحساب بعد حل جميع المشاكل.",
    deactivateGuidance: "عطّل الحساب إذا وُجدت مخالفات أو شكاوى من العملاء.",
    requestResubmission: "طلب إعادة الإرسال",
    requestedResubmission: "تم طلب إعادة الإرسال",
    resubmissionGuidance: "يجب على {role} تحديث معلوماته قبل الموافقة.",
    requestFailed: "فشل الطلب",
    failedToRequestResubmission: "فشل طلب إعادة الإرسال. يرجى المحاولة مرة أخرى.",
    userIdNotFound: "لم يتم العثور على معرف المستخدم",
    approveAccount: "قبول الحساب",
    rejectAccount: "رفض الحساب",
    approveContractor: "قبول المقاول",
    rejectContractor: "رفض المقاول",
    approveConsultant: "قبول الاستشاري",
    rejectConsultant: "رفض الاستشاري",
    rejectionFailed: "فشل الرفض",
    contractorIdNotFound: "لم يتم العثور على معرف المقاول",
    rejectedSuccessMessage: "تم {action} {name} بنجاح.",
    pleaseProvideDeactivationReason: "يرجى تقديم سبب للتعطيل.",
    accountDeactivatedMessage: "تم تعطيل حساب {role} بنجاح.",
    failedToDeactivate: "فشل تعطيل حساب {role}. يرجى المحاولة مرة أخرى.",
    accountReactivatedMessage: "تمت إعادة تفعيل حساب {role} بنجاح.",
    failedToReactivate: "فشل إعادة تفعيل حساب {role}. يرجى المحاولة مرة أخرى.",
    deactivateAccountTitle: "تعطيل حساب {role}؟",
    deactivateAccountBody: "سيؤدي تعطيل هذا الحساب إلى إزالة {role} مؤقتًا من قوائم العملاء ومنعه من استقبال طلبات خدمة جديدة. يمكن التراجع عن هذا الإجراء في أي وقت عبر إعادة تفعيل الحساب.",
    reasonForDeactivation: "سبب التعطيل",
    deactivationReasonPlaceholder: "يرجى تقديم سبب لتعطيل هذا الحساب...",
    unableToOpenDocument: "تعذر فتح المستند. يرجى التحقق من إعدادات حظر النوافذ المنبثقة.",
    documentOpened: "تم فتح المستند",
    licenseDocumentOpened: "تم فتح مستند الرخصة في تبويب جديد.",
    viewFailed: "فشل العرض",
    failedToOpenLicenseDocument: "فشل فتح مستند الرخصة. يرجى المحاولة مرة أخرى.",
    licenseDocumentUrlNotFound: "لم يتم العثور على رابط مستند الرخصة.",
    yearsExperience: "{years} {yearsText} خبرة",
    imageFileAlt: "ملف صورة",
    pdfFileAlt: "ملف PDF",
    documentFileAlt: "ملف مستند",
    portfolioImageAlt: "صورة المعرض",
    companyLogoAlt: "شعار الشركة"
    ,
    available: "متوفر",
    notAvailable: "غير متوفر",
    engineerApprovalDetails: "تفاصيل موافقة المهندس",
    engineerDetails: "تفاصيل المهندس",
    reviewEngineerRegistration: "مراجعة تسجيل المهندس والموافقة أو الرفض",
    viewEngineerInformation: "عرض معلومات وتفاصيل المهندس",
    engineerServices: "خدمات المهندس",
    hourlyRateAed: "السعر بالساعة (درهم)",
    inspectionAvailability: "توفر الفحص",
    selectTimeSlot: "اختر الفترة الزمنية",
    servicesOffering: "عروض الخدمات",
    noEngineerServices: "لم تتم إضافة خدمات"
  },
  quoteDetails: {
    quoteDetailsPage: "صفحة تفاصيل العرض",
    projectInfo: "معلومات المشروع",
    projectName: "اسم المشروع",
    projectType: "نوع المشروع",
    serviceType: "نوع الخدمة",
    requestedId: "معرف الطلب",
    quoteId: "معرف العرض",
    requestedDate: "تاريخ الطلب",
    projectRequirements: "متطلبات المشروع",
    mediaFiles: "الملفات الإعلامية",
    downloadAll: "تنزيل الكل",
    projectLayoutPlan: "خطة تخطيط المشروع",
    layoutPlan: "خطة التخطيط",
    architecturalDrawings: "الرسومات المعمارية (2D/3D)",
    structuralDrawings: "الرسومات الإنشائية",
    materialSpecificationSheet: "ورقة مواصفات المواد",
    propertyImages: "صور العقار",
    additionalFiles: "الملفات الإضافية",
    quotationProcess: "عرض السعر",
    requestProcess: "مسار الطلب",
    reviewRequest: "مراجعة الطلب",
    reviewProjectDetails: "راجع تفاصيل المشروع والملفات المرفقة. يجب عليك قبول أو رفض هذا الطلب خلال {days} {daysText}.",
    shareQuotationQuestion: "هل ترغب في مشاركة العرض لهذا الطلب؟",
    submitQuotation: "تقديم عرض السعر",
    submitQuotationTitle: "تقديم عرض السعر",
    interestPromptTitle: "هل أنت مهتم بتولي هذا الطلب؟",
    interestPromptSubtitle: "مهتم؟ أكد الآن وقدم عرض السعر خلال 72 ساعة.",
    interestPromptButton: "نعم، أنا مهتم!",
    adPostOnHoldNotice: "هذا الإعلان معلق. لا يمكن التعبير عن الاهتمام في الوقت الحالي.",
    enrollErrorUnavailable: "لا يمكن التسجيل. الإعلان غير متاح في الوقت الحالي.",
    prepareSubmitQuotation: "قم بتحضير وتقديم عرض السعر الخاص بك مع نطاق العمل، التسعير، والجدول الزمني. يجب أن ترسله خلال {days} {daysText} من قبول الطلب.",
    customerReviewConfirmation: "مراجعة العميل والتأكيد",
    customerWillReview: "سيقوم العميل بمراجعة عرض السعر الخاص بك. سيتم إشعارك بمجرد تأكيده.",
    loadingServices: "جارٍ تحميل الخدمات...",
    errorLoadingServices: "خطأ في تحميل الخدمات",
    licenseExpiredTooltip: "انتهت صلاحية رخصتك. يرجى تحديث الرخصة للمتابعة.",
    day: "يوم",
    days: "أيام",
    hour: "ساعة",
    hours: "ساعات",
    minute: "دقيقة",
    minutes: "دقائق",
    /** Abbrev. for acceptance countdown duration (same as full words in Arabic) */
    minShort: "دقيقة",
    minsShort: "دقائق",
    second: "ثانية",
    seconds: "ثوانٍ",
    requestAccepted: "تم قبول الطلب",
    requestRescheduled: "تم إعادة جدولة الطلب",
    requestAcceptedMessage: "لقد قبلت هذا الطلب (معرف الطلب: {requestId}). تم إشعار العميل باهتمامك.",
    interestSharedTitle: "تمت مشاركة اهتمامك مع العميل!",
    interestSharedMessage: "لقد قبلت هذا الطلب (معرف الإعلان: {adId}). تم إشعار العميل باهتمامك.",
    requestWillExpireOn: "ينتهي أجل طلبك في",
    requestDeclined: "تم رفض الطلب",
    requestDeclinedMessage: "لقد رفضت هذا الطلب. سيتم إبلاغ العميل أنك لن تتابع هذا العمل.",
    engineerDeclinedCustomerNotified: "لقد رفضت هذا الطلب. تم إشعار العميل.",
    engineerRejectionReasonBadge: "سبب الرفض:",
    rescheduleRequestedTitle: "تم طلب إعادة الجدولة",
    rescheduleRequestedMessage:
      "تم إرسال طلبك لإعادة جدولة المعاينة لموافقة العميل.",
    engineerSlotDetails: "تفاصيل الموعد",
    engineerRequestedSlot: "الموعد المطلوب:",
    engineerRescheduleSlot: "موعد إعادة الجدولة:",
    engineerRescheduleRequestSentTitle: "تم إرسال الطلب",
    engineerRescheduleRequestSentMessage: "تم إرسال طلب إعادة الجدولة.",
    engineerRescheduleRequestFailedTitle: "فشل الطلب",
    engineerRescheduleRequestFailedMessage:
      "تعذّر إرسال طلب إعادة الجدولة. يُرجى المحاولة مرة أخرى.",
    engineerRescheduleRequestSending: "جارٍ الإرسال…",
    engineerRescheduleModalTitle: "طلب إعادة الجدولة",
    engineerRescheduleModalDescription:
      "اقترح تاريخًا ووقتًا جديدين مع سبب لإعادة جدولة هذه المعاينة. يملك العميل 24 ساعة للموافقة.",
    engineerRescheduleModalDateLabel: "التاريخ والوقت المقترآن",
    engineerRescheduleModalReasonLabel: "سبب إعادة الجدولة",
    engineerRescheduleModalReasonPlaceholder: "يُرجى ذكر سبب إعادة الجدولة…",
    engineerRescheduleModalDatePlaceholder: "اختر التاريخ والوقت",
    engineerRescheduleModalSendRequest: "إرسال الطلب",
    engineerReasonForRescheduling: "سبب إعادة الجدولة",
    engineerAwaitingAcceptanceDescription:
      "يرجى الرد قبل {date}. يمكنك القبول أو الرفض أو طلب إعادة جدولة.",
    engineerAcceptanceMustRespondBefore: "يجب عليك القبول أو الرفض قبل {date}.",
    engineerAcceptanceMustRespondWithinDuration: "يجب عليك القبول أو الرفض خلال {duration}.",
    engineerAcceptanceDurationLessThanMinute: "أقل من دقيقة",
    engineerAcceptanceMustRespondExpired: "انتهى الموعد النهائي للرد.",
    engineerAcceptanceMustRespondFallback: "يجب عليك القبول أو الرفض خلال 3 أيام.",
    engineerAwaitingPaymentTitle: "في انتظار الدفع",
    engineerAwaitingPaymentDescription: "يجب على العميل إتمام الدفع قبل {date}.",
    engineerPaymentDeadlineReminder:
      "يجب إتمام الدفع قبل {date}. سيتم إلغاء الحجز تلقائيًا إذا لم يتم استلام الدفع.",
    engineerPaymentPastDeadlineBanner:
      "كان موعد استحقاق الدفع {date}. انتهى الموعد — قد يُلغى الحجز إذا لم يتم الدفع.",
    engineerPaymentAutoCancelledLabel: "⚠️ تم إلغاء الطلب تلقائيًا:",
    engineerPaymentAutoCancelledMessage:
      "لم يكمل العميل الدفع قبل الموعد النهائي. أُلغي في: {date}",
    engineerPendingReportSubtitle: "يجب على المهندس تقديم التقرير خلال 3 أيام (72 ساعة)",
    engineerPendingReportDueToday: "مستحق اليوم",
    engineerPendingReportDueInOneDay: "مستحق خلال يوم واحد",
    engineerPendingReportDueInDays: "مستحق خلال {days} أيام",
    engineerPendingReportOverdueDays: "متأخر {days} يوم",
    engineerPendingReportInfoTitle: "اكتملت الزيارة – تقديم التقرير النهائي",
    engineerPendingReportInfoBody:
      "أكمل تقرير المعاينة مع إجابات الأسئلة والأجوبة والتعليقات والمرفقات. قدّم التقرير خلال 3 أيام للحفاظ على جودة الخدمة.",
    engineerPendingReportCompleteButton: "إكمال الأسئلة والأجوبة وتقديم التقرير",
    engineerPendingReportAutosavePrefix: "الحفظ التلقائي مفعّل:",
    engineerPendingReportAutosaveRest: "تُحفظ إجاباتك تلقائيًا كمسودة",
    engineerPendingReportCompleted: "تم تقديم تقرير المعاينة.",
    engineerVisitReportEmpty: "لم يتم تضمين تفاصيل الأسئلة والأجوبة في التقرير المُقدَّم.",
    engineerReportSubmittedTitle: "تم إرسال التقرير",
    engineerReportSubmittedAwaitingReviewTitle: "تم إرسال التقرير – بانتظار مراجعة العميل",
    engineerRevisedReportSubmittedTitle: "تم إرسال التقرير المُعدَّل",
    engineerViewReportHistory: "عرض السجل",
    engineerReportHistoryTitle: "عرض السجل",
    engineerReportHistoryModalTitle: "سجل التقرير",
    engineerReportHistoryModalSubtitle:
      "اعرض جميع مراجعات التقرير المتبادلة بينك وبين المهندس. يُطبَّق أحدث تقرير على الطلب.",
    engineerReportHistoryDescription: "تقديمات التقرير لهذه المعاينة.",
    engineerReportHistoryLatest: "(الأحدث)",
    engineerReportHistoryInitial: "التقرير الأولي",
    engineerReportHistoryDetailTitle: "التقرير النهائي",
    engineerReportHistoryDetailLead: "تقرير المعاينة كما تم تقديمه لهذا العرض.",
    engineerReportHistoryOk: "حسناً",
    engineerReportHistoryEntrySubmitted: "تم إرسال التقرير",
    engineerReportHistoryEntryInReview: "تم رفع ملاحظة من العميل (قيد المراجعة)",
    engineerReportHistoryEmpty: "لا توجد مراحل لعرضها.",
    engineerIssueRaisedTitle: "تم رفع ملاحظة من العميل",
    engineerIssueRaisedSubtitle: "قام العميل برفع ملاحظة. يرجى الرد بسبب معتمد.",
    engineerIssueTypeLabel: "نوع الملاحظة",
    engineerIssueDescriptionLabel: "وصف الملاحظة",
    engineerIssueAttachedFilesLabel: "المرفقات",
    engineerIssueActionRequiredTitle: "إجراء مطلوب",
    engineerIssueActionRequiredBody:
      "العميل في انتظار ردك. ستبقى الدفعة في الضمان حتى تُحل هذه الملاحظة.",
    engineerIssueResubmittedNotice:
      "لقد أعدت إرسال تقريرك استجابةً لهذه الملاحظة. يمكن للعميل مراجعة الإرسال المُحدَّث.",
    engineerIssueResubmitReport: "إعادة إرسال التقرير",
    engineerIssueViewFile: "عرض",
    engineerIssueStepUpcomingHint:
      "إذا أبلغ العميل عن ملاحظة على تقريرك أثناء المراجعة، ستظهر التفاصيل هنا.",
    engineerIssueStepCompletedNoIssue: "لم يُبلَغ عن أي ملاحظة أثناء مراجعة العميل.",
    engineerIssueStepCompletedResolved: "تمت معالجة ملاحظة العميل ومتابعة المراجعة.",
    reportDetailsSectionLabel: "تفاصيل التقرير",
    inspectionDraftModalTitle: "مسودة تقرير المعاينة",
    submitInspectionReportTitle: "تقديم تقرير المعاينة",
    inspectionReportModalSubtitle: "أضف التقييمات وملخصًا لنتائج المعاينة.",
    inspectionReportDetailsPlaceholder:
      "قدّم ملخصًا تفصيليًا لنتائج المعاينة، بما في ذلك أي مشكلات أو مخاطر أو توصيات.",
    inspectionQATitle: "أسئلة وأجوبة المعاينة – أثناء الزيارة",
    inspectionQAProgressLabel: "التقدم:",
    inspectionQAProgressAnswered: "تمت الإجابة",
    inspectionQATextareaPlaceholder: "أدخل إجابتك التفصيلية...",
    inspectionQAAttachments: "المرفقات",
    inspectionQAUploadFile: "رفع ملف",
    inspectionQAUploadHint:
      "صور (JPEG، PNG، WebP، GIF، TIFF، BMP، HEIF/HEIC)، PDF، Word (.doc، .docx) — نفس صيغ محفظة التسجيل. بحد أقصى 10 ميجابايت لكل ملف.",
    inspectionQAInvalidFileType:
      "نوع الملف غير مسموح. المسموح: صور (JPEG، PNG، WebP، GIF، TIFF، BMP، HEIF/HEIC)، PDF، Word (.doc، .docx).",
    inspectionQASaveDraft: "حفظ المسودة",
    inspectionQADraftBannerTitle: "وضع المسودة",
    inspectionQADraftBannerBody:
      "يمكنك إعداد الإجابات ورفع المرفقات أثناء زيارتك. يتم الحفظ تلقائيًا. سيكون الإرسال النهائي متاحًا بعد تسجيل إتمام الزيارة.",
    inspectionQALoadFailed: "تعذر تحميل مسودة التقرير. يرجى المحاولة مرة أخرى.",
    inspectionQAEmpty: "لم تُرجع أي أسئلة لهذه المعاينة.",
    inspectionQAWordCount: "{current} / {max} كلمة",
    inspectionQAFileTooLarge: "يجب ألا يتجاوز حجم كل ملف {maxMb} ميجابايت.",
    inspectionQASaveSuccessTitle: "تم حفظ المسودة",
    inspectionQASaveSuccessMessage: "تم حفظ مسودة تقرير المعاينة بنجاح.",
    inspectionQASaveFailed: "تعذر حفظ المسودة. يرجى المحاولة مرة أخرى.",
    finalReportQATitle: "تقديم الإجابات النهائية للتقرير",
    finalReportOthersOptional: "أخرى (اختياري)",
    finalReportOthersPlaceholder: "أضف ملاحظات إذا رغبت...",
    finalReportSubmitReport: "تقديم التقرير",
    finalReportSubmitRequiresOneAnswer: "أدخل إجابة لسؤال واحد على الأقل قبل الإرسال.",
    finalReportSubmitRequiresAllAnswers:
      "قيّم كل فأتمم تفاصيل التقرير (بحد أقصى {maxWords} كلمة) ثم أرسل. المرفقات اختيارية.",
    finalReportSubmitSuccessTitle: "تم تقديم التقرير",
    finalReportSubmitSuccessMessage: "تم تقديم تقرير المعاينة بنجاح.",
    finalReportStatusChangeFailed: "تم حفظ المسودة، لكن تعذر تحديث الحالة. يرجى المحاولة مرة أخرى.",
    quotationSubmittedSuccessfully: "تم تقديم عرض السعر بنجاح في",
    customerWillReviewOffer: "سيقوم العميل الآن بمراجعة عرضك",
    quotationSubmittedDescription: "تم تقديم عرض السعر بنجاح في {dateTime}. سيقوم العميل الآن بمراجعة عرضك. (معرف عرض السعر: {quotationId}، مرتبط بمعرف الطلب: {requestId})",
    quotationAccepted: "تم قبول عرض السعر من قبل العميل. يمكن الآن متابعة المشروع.",
    quotationRejected: "تم رفض عرض السعر من قبل العميل.",
    quotationSubmittedReview: "تم تقديم عرض السعر وهو قيد المراجعة من قبل العميل.",
    prepareSubmitWithinDays: "قم بتحضير وتقديم عرض السعر خلال {days} {daysText} من القبول. يرجى تضمين تاريخ انتهاء عرض السعر.",
    serviceSelectionMandatory: "اختيار الخدمة إلزامي. يرجى اختيار عنصر خدمة واحد على الأقل للمتابعة",
    serviceListingSelected: "({selectedCount}/{totalCount} محدد)",
    uploadFileVersion: "قم بتحميل نسخة من عرض السعر الخاص بك (الصور، PDF، المستندات). الحد الأقصى للحجم: 50 ميجابايت.",
    uploadDesignFilesDescription: "قم بتحميل ملفات التصميم (صور، PDF، مستندات). يُسمح بتحميل عدة ملفات. يجب ألا يتجاوز الحجم الإجمالي لجميع الملفات 50 ميجابايت.",
    attachQuotationFileOptional: "إرفاق ملف العرض (اختياري)",
    attachDesignFiles: "إرفاق ملفات التصميم",
    submittedFiles: "الملفات المقدمة",
    attachedFile: "الملف المرفق",
    attachedFiles: "الملفات المرفقة",
    fileGenericName: "ملف {index}",
    uploadFile: "تحميل ملف",
    uploadFileVersionShort: "قم بتحميل نسخة من عرض السعر (PDF، Word، Excel). الحد الأقصى للحجم: 10 ميجابايت.",
    uploadFiles: "تحميل ملفات",
    uploadingFiles: "جارٍ تحميل الملفات...",
    submitting: "جاري الإرسال...",
    download: "تحميل",
    view: "عرض",
    downloadPdf: "تحميل PDF",
    viewFile: "عرض الملف",
    downloadDisabledClosed: "تم تعطيل التحميل - عرض السعر مغلق",
    attachedDesignFiles: "ملفات التصميم المرفقة",
    attachedQuotationFiles: "ملفات عرض السعر المرفقة",
    designRequirements: "متطلبات التصميم",
    quotationExpiryDate: "تاريخ انتهاء عرض السعر ",
    expiryDateMaxDays: "لا يمكن أن يتجاوز تاريخ الانتهاء {days} يومًا من اليوم.",
    setValidityPeriod: "حدد فترة صلاحية هذا العرض. بعد هذا التاريخ، لن يتمكن العميل من قبوله.",
    quotationRejectedTitle: "تم رفض عرض السعر",
    customerDidNotApprove: "لم يوافق العميل على عرض السعر الخاص بك.",
    reviewFeedback: "يرجى مراجعة تعليقاتهم أو انتظار طلب آخر.",
    reasonForRejection: "سبب الرفض الذي حصلنا عليه من العميل:",
    quotationAcceptedTitle: "تم قبول عرض السعر",
    customerApprovedQuotation: "وافق العميل على عرض السعر الخاص بك.",
    contactDetailsShared: "تمت مشاركة تفاصيل الاتصال الخاصة بك مع العميل. يرجى الانتظار لتلقي اتصالهم للمضي قدماً في الخطوات التالية.",
    customerAcceptedQuotationTitle: "وافق العميل على عرض السعر!",
    customerAcceptedQuotationDetails: "وافق العميل على عرض السعر الخاص بك ({quotationId}) بتاريخ {dateTime}. تمت مشاركة تفاصيل الاتصال الخاصة بك مع العميل. يرجى الانتظار لتلقي اتصالهم للمضي قدماً في الخطوات التالية.",
    requestExpired: "انتهت صلاحية الطلب",
    noActionTaken: "لم يتم اتخاذ أي إجراء خلال 5 أيام. تم إغلاق هذا الطلب ولا يمكن قبوله.",
    requestExpiredMessage: "لم يتم اتخاذ أي إجراء خلال {days} {daysText}. تم إغلاق هذا الطلب الآن ولا يمكن قبوله.",
    requestExpiredMessageEngineerByDueDate:
      "لم يتم اتخاذ أي إجراء قبل {dateTime}. تم إغلاق هذا الطلب الآن ولا يمكن قبوله.",
    quotationSubmittedTitle: "تم تقديم عرض السعر",
    quotationSubmittedMessage: "تم تقديم عرض السعر بنجاح في",
    submittedQuotationDetails: "تفاصيل العرض المقدم",
    total: "الإجمالي",
    notes: "ملاحظات",
    quotationExpiredTitle: "انتهت صلاحية عرض السعر",
    quotationExpiredMessage: "لم يرد العميل على عرض السعر الخاص بك ضمن الإطار الزمني المطلوب. انتهت صلاحية هذا العرض.",
    quotationNotSubmittedMessage: "لم تقدم عرض الأسعار الخاص بك في الإطار الزمني المطلوب. انتهت صلاحية دعوة المشروع هذه.",
    quotationExpiry: "انتهاء صلاحية عرض السعر",
    quotationExpiryMessage: "لم يرد العميل على عرض السعر الخاص بك [التاريخ] ضمن الإطار الزمني المطلوب. انتهت صلاحية هذا العرض.",
    quotationExpiryDescription: "لم يرد العميل على عرض السعر الخاص بك ({quotationId}) ضمن الإطار الزمني المطلوب. انتهت صلاحية هذا العرض.",
    declineInvitation: "رفض الدعوة",
    declineProjectInvitation: "رفض دعوة المشروع",
    provideReasonForDeclining: "يرجى تقديم سبب للرفض",
    provideReasonForDecliningInvitation: "يرجى تقديم سبب لرفض هذه الدعوة...",
    cancel: "إلغاء",
    confirmInspectionVisitCompletedTitle: "تأكيد إتمام زيارة التفتيش",
    confirmInspectionVisitCompletedSubtext: "أكد أنك أتممت زيارة التفتيش في الموقع.",
    confirmInspectionVisitCompletedInfo:
      "بعد التأكيد، سيكون لديك 3 أيام (72 ساعة) لتقديم تقرير التفتيش مع جميع إجابات الأسئلة والأجوبة.",
    confirmVisitCompletedPrimaryButton: "تأكيد إتمام الزيارة",
    engineerVisitMissedTitle: "تم تفويت الزيارة",
    engineerVisitMissedDescription: "لم يكمل المهندس الزيارة خلال 24 ساعة من الموعد المحدد",
    engineerRefundInitiatedTitle: "تم بدء الاسترداد",
    engineerRefundInitiatedDescription:
      "طلب العميل استرداد المبلغ. يتم إعادة مبلغ الضمان إلى العميل.",
    engineerRefundRequestedTitle: "طلب استرداد",
    engineerRefundRequestedDescription:
      "تم طلب استرداد المبلغ لهذه المعاينة. سيتم إشعارك عند معالجته.",
    engineerRefundedTitle: "تم الاسترداد",
    engineerRefundedDescription: "اكتمل استرداد المبلغ لهذه المعاينة.",
    engineerMarkVisitCompletedButton: "تعليم الزيارة كمكتملة",
    engineerTimelineCompletedPaymentReleasedTitle: "مكتمل - تم تحرير الدفع",
    engineerTimelineCompletedPaymentReleasedDescription:
      "تم تحرير دفعة الضمان لك. تم التأكيد في {dateTime}.",
    declining: "في طريق الرفض...",
    rejectRequestTitle: "رفض الطلب",
    rejectRequestSubtitle:
      "يُرجى إدخال سبب رفض هذا الطلب. سيتم مشاركته مع العميل.",
    rejectionReasonFieldLabel: "سبب الرفض",
    reasonForRejectionFieldLabel: "سبب الرفض",
    rejectReasonOutsideServiceArea: "خارج نطاق الخدمة",
    rejectReasonAlreadyBooked: "محجوز بالفعل في هذا الموعد",
    rejectReasonInsufficientInfo: "معلومات المشروع غير كافية",
    rejectReasonOther: "أخرى",
    rejectReasonPlaceholder: "يرجى توضيح سبب الرفض.",
    confirmRejection: "تأكيد الرفض",
    rejectValidationRequired: "يرجى اختيار فئة وإدخال سبب الرفض.",
    buildingName: "اسم المبنى",
    adInfo: "معلومات الإعلان",
    adPostedOn: "تم نشر الإعلان في",
    propertyName: "اسم العقار",
    propertyType: "نوع العقار",
    requestId: "رقم الطلب",
    bookedSlot: "الموعد المحجوز",
    adId: "معرف الإعلان",
    postedDate: "تاريخ النشر",
    viewFileName: "عرض {fileName}",
    downloadFileName: "تحميل {fileName}",
    fileUnavailable: "الملف غير متاح حاليًا",
    unableToDownloadFile: "تعذر تحميل الملف.",
    loadMore: "تحميل المزيد",
    locationNotSpecified: "الموقع غير محدد",
    customerInfo: "معلومات العميل",
    customerName: "اسم العميل",
    phoneNumber: "رقم الهاتف",
    emailId: "البريد الإلكتروني",
    address: "العنوان",
    zipcode: "الرمز البريدي",
    status: "الحالة",
    statusLabelNew: "جديد",
    projectInformation: "معلومات المشروع",
    requestedOn: "تم الطلب في",
    accept: "قبول",
    decline: "رفض",
    accepting: "جاري القبول...",
    declining: "جاري الرفض...",
    acceptingRequest: "جاري قبول الطلب...",
    decliningRequest: "جاري رفض الطلب...",
    sendQuotation: "إرسال عرض السعر",
    totalBuiltUpArea: "إجمالي المساحة المبنية",
    enterTotalBuiltUpAreaDescription: "أدخل إجمالي المساحة المبنية التي يغطيها هذا العرض واختر الوحدة المناسبة.",
    selectUnit: "اختر الوحدة",
    enterTotalBuildUpArea: "أدخل إجمالي المساحة المبنية",
    services: "الخدمات",
    serviceItems: "عناصر الخدمة",
    unit: "الوحدة",
    qty: "الكمية",
    ratePerUnit: "السعر لكل وحدة",
    amount: "المبلغ",
    currencyAed: "درهم",
    addAmount: "إضافة مبلغ",
    services: "الخدمات",
    service: "الخدمة",
    additionalServices: "الخدمات الإضافية",
    addMore: "+ إضافة المزيد",
    subTotal: "المجموع الفرعي",
    consultantFees: "رسوم الاستشاري",
    requestCreated: "تم إنشاء الطلب",
    requestCreatedDescription: "تم إنشاء طلب خدمة جديد لهذا المشروع.",
    requestInProgress: "الطلب قيد التنفيذ",
    requestInProgressDescription: "لقد قبلت هذا الطلب (معرف الطلب: {requestId}). تم إشعار العميل باهتمامك.",
    submittedQuotationServices: "خدمات عرض السعر المقدّم",
    itemName: "اسم البند",
    thirdLevelAlt: "المستوى الثالث",
    reasonForDeclineOptional: "سبب الرفض (اختياري)",
    reasonForDeclining: "سبب الرفض:",
    placeholders: {
      enterItemName: "أدخل اسم البند...",
      serviceName: "اسم الخدمة",
      addNotes: "أضف ملاحظات"
    },
    validation: {
      expiryDateRequired: "يرجى تحديد تاريخ انتهاء للمتابعة",
      expiryDateFutureOnly: "يجب أن يكون تاريخ انتهاء عرض السعر تاريخًا مستقبليًا (لا يُسمح بالتواريخ الحالية أو السابقة)",
      totalBuiltUpAreaRequired: "إجمالي المساحة المبنية مطلوب",
      totalBuiltUpAreaUnitRequired: "يرجى اختيار وحدة لإجمالي المساحة المبنية",
      consultantFeesPercentageRequired: "نسبة رسوم الاستشاري مطلوبة",
      serviceNameRequired: "اسم الخدمة مطلوب",
      unitRequired: "الوحدة مطلوبة",
      quantityGreaterThanZero: "يجب أن تكون الكمية أكبر من 0",
      quantityMustBeOneForLS: "يجب أن تكون الكمية 1 لوحدة L.S",
      rateGreaterThanZero: "يجب أن يكون السعر أكبر من 0",
      invalidNumberSingleDecimal: "صيغة غير صحيحة: يُسمح بعلامة عشرية واحدة فقط"
    },
    toast: {
      invitationAcceptedTitle: "تم قبول الدعوة",
      invitationAcceptedMessage: "لقد قبلت دعوة المشروع بنجاح. يمكنك الآن المتابعة لتقديم عرض السعر.",
      acceptFailedTitle: "فشل القبول",
      acceptFailedFallbackMessage: "تعذر قبول الدعوة. يرجى المحاولة مرة أخرى.",
      invitationDeclinedTitle: "تم رفض الدعوة",
      invitationDeclinedMessage: "لقد رفضت دعوة المشروع بنجاح.",
      declineFailedTitle: "فشل الرفض",
      declineFailedFallbackMessage: "تعذر رفض الدعوة. يرجى المحاولة مرة أخرى.",
      uploadFailedTitle: "فشل التحميل",
      unableToUploadMessage: "تعذر تحميل: {fileNames}. يرجى التحقق من الملف(ات) ثم المحاولة مرة أخرى.",
      uploadErrorFallbackMessage: "حدث خطأ أثناء تحميل الملفات. يرجى المحاولة مرة أخرى.",
      failedToUploadFilesMessage: "فشل تحميل الملفات: {errorMessage}",
      collectionErrorTitle: "خطأ في التجميع",
      collectionErrorMessage: "لم يتم تحميل بيانات الخدمات بشكل صحيح. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
      validationErrorTitle: "خطأ في التحقق",
      invalidUnitsMessage: "توجد عناصر بوحدات غير صالحة. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
      quotationSubmittedTitle: "تم تقديم عرض السعر",
      quotationSubmittedMessage: "تم تقديم عرض السعر بنجاح!",
      submissionFailedTitle: "فشل الإرسال",
      submissionFailedFallbackMessage: "فشل تقديم عرض السعر. يرجى المحاولة مرة أخرى.",
      multipleFilesTitle: "ملفات متعددة",
      multipleFilesMessage: "يرجى اختيار ملف واحد فقط في كل مرة.",
      invalidFilesTitle: "ملفات غير صالحة",
      fileSizeLimitTitle: "حد حجم الملف",
      duplicateFilesTitle: "ملفات مكررة",
      duplicateFileTitle: "ملف مكرر",
      duplicateFileAlreadyAttached: "الملف \"{fileName}\" مرفق بالفعل.",
      multipleDuplicateFilesAlreadyAttachedList: "هذه الملفات مرفقة بالفعل: {fileNames}",
      visitMarkedCompletedTitle: "تم تسجيل إتمام الزيارة",
      visitMarkedCompletedMessage: "تم تسجيل زيارة التفتيش كمكتملة. يمكنك الآن تقديم تقريرك خلال 72 ساعة.",
      visitMarkedCompletedFailedTitle: "تعذر تحديث الحالة",
      visitMarkedCompletedFailedMessage: "فشل تسجيل إتمام الزيارة. يرجى المحاولة مرة أخرى.",
      visitMarkedCompletedInvalidQuotation: "تعذر العثور على عرض السعر. يرجى تحديث الصفحة والمحاولة مرة أخرى."
    }
  },
  serviceProvider: {
    dashboard: {
      pageTitle: "لوحة تحكم مزود الخدمة",
      pageTitleEngineer: "لوحة تحكم المهندس",
      title: "لوحة القيادة",
      subtitle: "مرحباً بعودتك! إليك ما يحدث في مشاريعك.",
      availability: {
        label: "التوفر",
        updating: "جارٍ التحديث..."
      },
      toast: {
        availabilityUpdatedTitle: "تم تحديث التوفر",
        availabilityUpdatedMessage: "أنت الآن {status} للمشاريع الجديدة.",
        updateFailedTitle: "فشل التحديث",
        updateFailedMessage: "فشل تحديث حالة التوفر. يرجى المحاولة مرة أخرى.",
        updateErrorMessage: "حدث خطأ أثناء تحديث حالة التوفر. يرجى المحاولة مرة أخرى.",
        toggleFailedTitle: "فشل التبديل",
        toggleFailedMessage: "حدث خطأ أثناء تبديل حالة التوفر. يرجى المحاولة مرة أخرى."
      },
      metrics: {
        totalQuotations: "إجمالي عروض الأسعار",
        submittedByRole: "{role} قدم",
        customerAccepted: "مقبول من العميل",
        customerRejected: "مرفوض من العميل",
        avgTurnaround: "متوسط مدة التنفيذ",
        successRate: "نسبة النجاح"
      },
      alts: {
        totalRequestedQuotes: "إجمالي عروض الأسعار المطلوبة",
        quotesSubmitted: "عروض الأسعار المقدمة",
        customerAccepted: "مقبول من العميل",
        customerRejected: "مرفوض من العميل"
      },
      error: {
        title: "فشل تحميل إحصائيات لوحة التحكم",
        message: "يرجى تحديث الصفحة أو التواصل مع الدعم إذا استمرت المشكلة."
      },
      recentlyRequested: "الطلبات الأخيرة",
      recentlySubmitted: "المقدم حديثاً",
      dueLabel: "الاستحقاق:",
      empty: {
        requestedQuotes: "لا توجد عروض أسعار مطلوبة",
        recentQuotes: "لا توجد عروض أسعار حديثة"
      }
    }
    ,
    invitations: {
      pageTitle: "الطلبات المستلمة"
    },
    quotes: {
      pageTitle: "العروض المقدمة"
    },
    profile: {
      tabs: {
        myServices: "خدماتي",
        accountSettings: "إعدادات الحساب"
      },
      save: "حفظ",
      saving: "جاري الحفظ...",
      saveServices: "حفظ الخدمات",
      accountSettings: {
        validation: {
          currentPasswordRequired: "كلمة المرور الحالية مطلوبة",
          newPasswordRequired: "كلمة المرور الجديدة مطلوبة",
          currentPasswordIncorrect: "كلمة المرور الحالية غير صحيحة",
          authTokenMissing: "لم يتم العثور على رمز المصادقة. يرجى تسجيل الدخول مرة أخرى.",
          networkError: "خطأ في الشبكة. يرجى التحقق من الاتصال والمحاولة مرة أخرى.",
          passwordUpdateFailedFallback: "فشل تحديث كلمة المرور. يرجى المحاولة مرة أخرى.",
          emailVerificationTokenMissing: "رمز التحقق من البريد الإلكتروني مفقود. يرجى التحقق من بريدك الإلكتروني أولاً."
        },
        toast: {
          passwordUpdateFailedTitle: "فشل تحديث كلمة المرور",
          passwordUpdatedTitle: "تم تحديث كلمة المرور",
          passwordUpdatedMessage: "تم تحديث كلمة المرور بنجاح.",
          otpSentTitle: "تم إرسال رمز التحقق",
          otpSendFailedTitle: "فشل إرسال رمز التحقق",
          emailOtpSentMessage: "تم إرسال رمز تحقق إلى بريدك الإلكتروني.",
          mobileOtpSentMessage: "تم إرسال رمز تحقق إلى رقم هاتفك المحمول.",
          phoneOtpSentMessage: "تم إرسال رمز تحقق إلى رقم هاتفك الجديد.",
          failedToSendOtpMessage: "فشل إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
          failedToSendOtpFallback: "فشل إرسال رمز التحقق",
          phoneUpdatedTitle: "تم تحديث رقم الهاتف",
          phoneUpdatedMessage: "تم تحديث رقم هاتفك بنجاح.",
          licenseSubmittedTitle: "تم تقديم الرخصة للمراجعة",
          licenseSubmittedMessage: "تم تقديم رخصتك للمراجعة. سيتم إخطارك عند الموافقة عليها.",
          licenseUpdateFailedTitle: "فشل تحديث الرخصة",
          profileUpdatedTitle: "تم تحديث الملف الشخصي بنجاح!",
          profileUpdatedMessage: "تم تحديث ملفك الشخصي بنجاح.",
          profileUpdateFailedTitle: "فشل تحديث الملف الشخصي",
          profileUpdateFailedMessage: "فشل تحديث ملفك الشخصي. يرجى المحاولة مرة أخرى.",
          uploadFailedTitle: "فشل التحميل"
        },
        license: {
          licenseDocumentRequired: "يرجى تحميل مستند الرخصة لتقديمه للموافقة عليه"
        },
        deleteAccount: {
          verificationRequiredTitle: "التحقق مطلوب",
          verificationRequiredMessage: "رمزا التحقق من البريد الإلكتروني والهاتف المحمول مطلوبان لحذف حسابك."
        },
        bankAccounts: {
          title: "الحسابات البنكية",
          subtitle: "إدارة حساباتك البنكية لصرف المدفوعات",
          emptyTitle: "لم تُضف حسابات بنكية",
          emptySubtitle: "أضف حسابك البنكي لاستلام مدفوعات الصرف",
          addButton: "إضافة حساب بنكي",
          notePrefix: "ملاحظة:",
          footerNote: "تتطلب جميع الحسابات البنكية التحقق من الإدارة قبل استخدامها للمدفوعات.",
          addModalTitle: "إضافة حساب بنكي",
          importantNotice:
            "مهم: ستتحقق الإدارة من جميع البيانات البنكية قبل معالجة المدفوعات. تأكد من تطابق المعلومات مع المستندات الرسمية للبنك.",
          bankAccountDetails: "تفاصيل الحساب البنكي",
          bankName: "اسم البنك",
          bankNamePlaceholder: "مثل: الإمارات دبي الوطني، أدكب، بنك دبي الإسلامي",
          accountHolderName: "اسم صاحب الحساب",
          accountHolderPlaceholder: "يجب أن يطابق اسم الرخصة التجارية",
          accountHolderHint: "يجب أن يطابق تمامًا اسم شركتك في الرخصة التجارية",
          accountNumber: "رقم الحساب",
          accountNumberPlaceholder: "أدخل رقم الحساب",
          accountType: "نوع الحساب",
          currentAccount: "حساب جاري",
          savingsAccount: "حساب توفير",
          iban: "الآيبان IBAN",
          ibanPlaceholder: "AE070260001234567890123",
          ibanHint: "صيغة الآيبان الإماراتي: 23 حرفًا تبدأ بـ AE",
          swiftBic: "رمز SWIFT/BIC",
          swiftPlaceholder: "مثل EBILAED",
          branchCode: "رمز الفرع",
          branchCodePlaceholder: "مثل 026",
          branchName: "اسم الفرع",
          branchNamePlaceholder: "مثل: فرع الشارقة الصناعي",
          primaryCheckbox: "تعيين كحساب أساسي للمدفوعات",
          primaryCheckboxHint: "سيُستخدم الحساب الأساسي افتراضيًا لجميع صرف المدفوعات",
          supportingDocuments: "المستندات الداعمة",
          supportingDocumentsIntro: "ارفع أحد المستندات التالية على الأقل للتحقق:",
          docBankLetter: "خطاب بنكي",
          docCancelledCheque: "شيك ملغى",
          docBankStatement: "كشف حساب بنكي",
          uploadClick: "انقر لرفع المستندات",
          uploadFormats: "PDF أو JPG أو PNG (بحد أقصى 5 ميجابايت لكل ملف)",
          verificationProcessTitle: "عملية التحقق",
          verificationBullet1: "أرسل التفاصيل والمستندات عبر هذا النموذج.",
          verificationBullet2: "يراجع فريقنا معلوماتك مقابل سجلاتك الرسمية.",
          verificationBullet3: "ستصلك إشعارًا عند التحقق من الحساب أو إذا لزم معلومات إضافية.",
          verificationBullet4: "يمكن استخدام الحسابات الموثقة لصرف المدفوعات من المنصة.",
          cancel: "إلغاء",
          addAccount: "إضافة الحساب",
          submitting: "جاري الإرسال…",
          labelAccountType: "نوع الحساب",
          labelAccountNumber: "رقم الحساب",
          labelIban: "الآيبان",
          statusVerified: "تم التحقق",
          primaryBadge: "أساسي",
          statusPending: "قيد التحقق",
          verifiedOn: "تم التحقق في",
          deleteAria: "حذف الحساب البنكي",
          toast: {
            addedTitle: "تمت إضافة الحساب",
            addedMessage: "تم حفظ حسابك البنكي. سيظهر قيد التحقق حتى تتم مراجعته من الإدارة.",
            removedTitle: "تم حذف الحساب",
            removedMessage: "تمت إزالة الحساب البنكي من ملفك.",
            validationTitle: "معلومات ناقصة",
            validationMessage: "يرجى تعبئة جميع الحقول البنكية المطلوبة.",
            documentsRequiredTitle: "المستندات مطلوبة",
            documentsRequiredMessage: "يرجى رفع مستند داعم واحد على الأقل.",
            fileTooLargeTitle: "الملف كبير جدًا",
            fileTooLargeMessage: "يجب ألا يتجاوز كل ملف 5 ميجابايت."
          }
        }
      }
    },
    engineerPayments: {
      pageTitle: "المدفوعات",
      title: "المدفوعات",
      subtitle: "إدارة وتتبع جميع معاملاتك المالية",
      summary: {
        totalEarnings: "إجمالي الأرباح",
        inEscrow: "قيد الضمان",
        pendingPayments: "مدفوعات معلقة",
        completedThisMonth: "مكتملة هذا الشهر"
      },
      tabs: {
        all: "الكل",
        completed: "مكتمل",
        inEscrow: "قيد الضمان",
        pending: "معلق"
      },
      searchPlaceholder: "البحث في المدفوعات...",
      serviceType: "نوع الخدمة",
      serviceTypeAll: "كل الأنواع",
      export: "تصدير",
      columns: {
        requestId: "رقم الطلب",
        customer: "العميل",
        serviceType: "نوع الخدمة",
        amount: "المبلغ",
        date: "التاريخ",
        status: "الحالة",
        actions: "إجراءات"
      },
      view: "عرض",
      amountBreakdown: "{rate} درهم/ساعة × {hours} س",
      releasedOn: "صُرفت: {date}",
      empty: "لا توجد مدفوعات تطابق عوامل التصفية.",
      loading: "جاري تحميل المدفوعات…",
      loadError: "تعذر تحميل المدفوعات. يرجى المحاولة مرة أخرى.",
      paginationPrev: "السابق",
      paginationNext: "التالي",
      paginationPage: "صفحة {page} من {totalPages}",
      paginationShowing: "عرض {from}–{to} من {total}",
      statusInEscrow: "قيد الضمان",
      statusPending: "معلق",
      statusCompleted: "مكتمل",
      statusUnknown: "غير معروف",
      serviceTypes: {
        inspection: "فحص",
        quantification: "كميات"
      },
      modal: {
        title: "تفاصيل الدفع",
        paymentStatus: "حالة الدفع",
        amount: "المبلغ",
        requestId: "رقم الطلب",
        customerName: "اسم العميل",
        serviceType: "نوع الخدمة",
        paymentDate: "تاريخ الدفع",
        escrowReleaseDate: "تاريخ صرف الضمان",
        rateBreakdown: "تفصيل السعر",
        hourlyRate: "السعر بالساعة",
        totalHours: "إجمالي الساعات",
        hoursUnit: "ساعات",
        totalAmount: "المبلغ الإجمالي",
        escrowInfo: "معلومات الضمان",
        escrowBullet1: "يُحتفظ بالدفع في الضمان حتى اكتمال الفحص",
        escrowBullet2: "قدّم التقرير خلال 3 أيام بعد الفحص",
        escrowBullet3: "يُصرف المبلغ بعد تأكيد العميل",
        downloadInvoice: "تنزيل الفاتورة",
        viewRequestDetails: "عرض تفاصيل الطلب",
        loadingDetails: "جاري تحميل التفاصيل…",
        detailLoadError: "تعذر تحميل تفاصيل الدفع الكاملة. يتم عرض بيانات القائمة.",
        breakdown: "التفصيل"
      }
    }
  },
  status: {
    pending: "قيد الانتظار",
    new: "جديد",
    created: "تم الإنشاء",
    submitted: "مقدم",
    approved: "مقبول",
    licenseApproved: "الرخصة مقبولة",
    licenseRejected: "الرخصة مرفوضة",
    customerAccepted: "مقبول من العميل",
    customerRejected: "مرفوض من العميل",
    declined: "مرفوض",
    closed: "مغلق",
    inProgress: "قيد التنفيذ",
    visitScheduled: "تم جدولة الزيارة",
    visited: "تمت الزيارة",
    visitMissed: "فُوتت الزيارة",
    reportSubmitted: "تم تقديم التقرير",
    awaitingPayment: "في انتظار الدفع",
    paymentPendingExpired: "انتهت صلاحية الدفع",
    awaitingAcceptance: "في انتظار القبول",
    completed: "مكتمل",
    expired: "منتهي",
    createdExpired: "تم الإنشاء منتهي",
    inProgressExpired: "قيد التنفيذ منتهي",
    submittedExpired: "مقدم منتهي",
    licenseExpired: "الرخصة منتهية",
    cancelled: "ملغى",
    active: "نشط",
    inactive: "غير نشط",
    licenseResubmitted: "إعادة تقديم الرخصة",
    licenseExpiredCap: "انتهت الرخصة",
    underReview: "قيد المراجعة",
    onHold: "معلق",
    archived: "مؤرشف",
    deactivated: "معطل",
    disabled: "معطل",
    unknown: "غير معروف"
  },
  tableHeaders: {
    type: "النوع",
    projectDetails: "تفاصيل المشروع",
    customer: "العميل",
    project: "المشروع",
    created: "تاريخ الإنشاء",
    dueDate: "تاريخ الاستحقاق",
    contactShared: "تمت مشاركة الاتصال",
    submitted: "تاريخ التقديم",
    order: "الترتيب",
    offerTitle: "عنوان العرض",
    image: "صورة",
    lastUpdated: "آخر تحديث",
    createdDate: "تاريخ الإنشاء"
  },
  menu: {
    contractors: "المقاولون",
    engineers: "المهندسون",
    consultants: "المستشارون",
    customers: "العملاء"
  },
  header: {
    openSidebar: "فتح الشريط الجانبي",
    notifications: "الإشعارات",
    loadingNotifications: "جارٍ تحميل الإشعارات...",
    noNotifications: "لا توجد إشعارات",
    noUser: "لا يوجد مستخدم",
    noRole: "لا توجد صلاحية",
    noEmail: "لا يوجد بريد إلكتروني",
    signOut: "تسجيل الخروج"
  },
  general: {
    eng: "ENG",
    arabic: "العربية",
    am: "ص",
    pm: "م",
    viewAll: "عرض الكل",
    available: "متوفر",
    unavailable: "غير متوفر",
    search: "بحث",
    filters: "الفلاتر",
    listView: "عرض القائمة",
    gridView: "عرض الشبكة",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    to: "إلى",
    clear: "مسح",
    clearAll: "مسح الكل",
    close: "إغلاق",
    yes: "نعم",
    no: "لا",
    unknown: "غير معروف",
    allTypes: "جميع الأنواع",
    viewQuotes: "عرض عروض الأسعار",
    pageOf: "الصفحة {page} من {totalPages}",
    showingResults: "عرض {from} إلى {to} من {total} نتيجة",
    noData: "لا توجد بيانات",
    noDataAvailable: "لا توجد بيانات متاحة",
    noRecordsToDisplay: "لا توجد سجلات لعرضها في الوقت الحالي.",
    tryAdjustingFilters: "حاول تعديل البحث أو الفلاتر للعثور على المزيد من {item}.",
    tryAdjustingSearch: "حاول تعديل معايير البحث أو الفلتر.",
    noQuotesAvailable: "لا توجد عروض أسعار متاحة في الوقت الحالي.",
    noRequestsAvailable: "لا توجد طلبات متاحة في الوقت الحالي.",
    noQuotationsYet: "لم يتلق هذا العميل أي عروض أسعار بعد.",
    noQuantificationsYet: "ليس لديك طلبات تقدير كميات بعد.",
    noInspectionsYet: "ليس لديك طلبات فحص بعد.",
    noQuotesFound: "لم يتم العثور على عروض أسعار",
    noRequestsFound: "لم يتم العثور على طلبات",
    noQuotationsFound: "لم يتم العثور على عروض أسعار",
    noQuantificationsFound: "لم يتم العثور على تقديرات كميات",
    noInspectionsFound: "لم يتم العثور على فحوصات",
    noProjectsFound: "لم يتم العثور على مشاريع",
    quotes: "عروض الأسعار",
    requests: "الطلبات",
    quotations: "عروض الأسعار",
    projects: "المشاريع",
    quantifications: "تقديرات الكميات",
    inspections: "الفحوصات"
  },
  contentManagement: {
    // عنوان الصفحة
    pageTitle: "قائمة المواد الرئيسية",
    pageDescription: "إدارة جميع المواد والعلامات التجارية المتاحة على المنصة. العناصر المعتمدة ستكون متاحة للموردين للاختيار والعرض.",
    // شريط طلبات الموردين
    supplierRequestsBanner: "{count} طلبات موردين – تحتاج مراجعة",
    reviewNewRequest: "مراجعة طلب جديد",
    // لوحة الشجرة
    materialList: "قائمة المواد",
    addMainCategory: "إضافة فئة رئيسية",
    addSubCategory: "إضافة فئة فرعية",
    addMaterial: "إضافة مادة",
    addBrand: "إضافة علامة تجارية",
    addSize: "إضافة حجم",
    // عناوين النماذج
    editMainCategory: "تعديل الفئة الرئيسية",
    editSubCategory: "تعديل الفئة الفرعية",
    editMaterial: "تعديل المادة",
    // تسميات النماذج
    mainCategory: "الفئة الرئيسية",
    subCategory: "الفئة الفرعية",
    material: "المادة",
    nameEnglish: "اسم {entity} (إنجليزي)",
    nameArabic: "اسم {entity} (عربي)",
    enterName: "أدخل اسم {entity}",
    addImage: "إضافة صورة",
    size: "الحجم",
    unitType: "نوع الوحدة",
    brands: "العلامات التجارية",
    brandName: "اسم العلامة التجارية",
    uploadImage: "رفع صورة",
    dragDropUpload: "اسحب وأفلت أو ارفع صورة",
    imageRequirements: "يدعم جميع صيغ الصور؛ يُنصح بـ PNG",
    imageDimensions: "١٨٠×١٨٠ بكسل، ١:١ (مربع)، حد أقصى ٥ ميجابايت",
    selectMainCategory: "اختر الفئة الرئيسية",
    selectSubCategory: "اختر الفئة الفرعية",
    selectCategory: "— اختر —",
    // أنواع الوحدات
    inch: "إنش",
    cm: "سم",
    mm: "مم",
    meter: "متر",
    feet: "قدم",
    // الأزرار
    save: "حفظ",
    saving: "جارٍ الحفظ...",
    cancel: "إلغاء",
    close: "إغلاق",
    delete: "حذف",
    archive: "أرشفة",
    // الشارات
    new: "جديد",
    review: "مراجعة",
    // الحالة الفارغة
    emptyState: "اختر عنصرًا أو انقر \"إضافة\" للبدء",
    // نافذة الحذف/الأرشفة
    confirmDelete: "تأكيد الحذف",
    cannotDelete: "لا يمكن الحذف",
    confirmDeleteMessage: "هل أنت متأكد من حذف {name}؟ لا يمكن التراجع عن هذا الإجراء.",
    cascadeDeleteMainCategory: "تحتوي هذه الفئة على فئات فرعية ومواد. سيؤدي حذفها إلى إزالة جميع الفئات الفرعية والمواد المرتبطة نهائياً. هل أنت متأكد من المتابعة؟",
    cascadeDeleteSubCategory: "تحتوي هذه الفئة الفرعية على مواد. سيؤدي حذفها إلى إزالة جميع المواد المرتبطة نهائياً. هل أنت متأكد من المتابعة؟",
    hasQuotationsMessage: "هذه الفئة أو موادها مرتبطة بعروض أسعار حالية. يمكنك أرشفتها بدلاً من ذلك.",
    // رسائل التنبيه
    mainCategoryCreated: "تم إنشاء الفئة الرئيسية بنجاح",
    mainCategoryUpdated: "تم تحديث الفئة الرئيسية بنجاح",
    subCategoryCreated: "تم إنشاء الفئة الفرعية بنجاح",
    subCategoryUpdated: "تم تحديث الفئة الفرعية بنجاح",
    materialCreated: "تم إنشاء المادة بنجاح",
    materialUpdated: "تم تحديث المادة بنجاح",
    mainCategoryDeleted: "تم حذف الفئة الرئيسية",
    subCategoryDeleted: "تم حذف الفئة الفرعية",
    materialDeleted: "تم حذف المادة",
    mainCategoryArchived: "تم أرشفة الفئة الرئيسية",
    subCategoryArchived: "تم أرشفة الفئة الفرعية",
    materialArchived: "تم أرشفة المادة",
    nameEnRequired: "الاسم (إنجليزي) مطلوب",
    nameArRequired: "الاسم (عربي) مطلوب",
    operationFailed: "فشلت العملية. يرجى المحاولة مرة أخرى.",
    deleteFailed: "فشل الحذف. يرجى المحاولة مرة أخرى.",
    archiveFailed: "فشلت الأرشفة. يرجى المحاولة مرة أخرى.",
    invalidImageType: "صيغة صورة غير مدعومة. يرجى استخدام PNG أو JPG أو GIF أو WebP.",
    imageTooLarge: "الصورة كبيرة جداً. الحد الأقصى ٥ ميجابايت.",
    brandCreationFailed: "فشل إنشاء العلامة التجارية \"{name}\". يرجى المحاولة مرة أخرى."
  },
  supplier: {
    dashboard: {
      pageTitle: "لوحة التحكم",
      title: "لوحة تحكم المورد",
      subtitle: "مرحباً بك في بوابة الموردين"
    },
    requests: {
      pageTitle: "الطلبات"
    },
    ads: {
      pageTitle: "نشر إعلان"
    },
    quotations: {
      pageTitle: "عروض الأسعار"
    },
    suppliers: {
      pageTitle: "الموردون"
    },
    reports: {
      pageTitle: "التقارير"
    },
    wishlist: {
      pageTitle: "قائمة الأمنيات",
      empty: "لا يوجد موردون محفوظون بعد",
      emptySubtitle: "تصفح الموردين واحفظ من يثير اهتمامك."
    },
    support: {
      pageTitle: "الدعم",
      faqTitle: "الأسئلة الشائعة",
      contactTitle: "تواصل معنا",
      submitTicket: "إرسال طلب دعم"
    },
    profile: {
      pageTitle: "حسابي"
    },
    orders: {
      pageTitle: "الطلبات المقدمة",
      title: "الطلبات المقدمة",
      subtitle: "عرض جميع الطلبات التي قدّمها المقاولون لموادك.",
      searchPlaceholder: "ابحث برقم الطلب أو اسم المشروع أو العميل...",
      moreFilters: "مزيد من الفلاتر",
      ordered: "تاريخ الطلب",
      delivery: "التسليم",
      items: "عناصر",
      viewDetails: "عرض التفاصيل",
      noOrders: "لا توجد طلبات",
      noOrdersSubtitle: "ستظهر هنا الطلبات المطابقة للفلاتر.",
      showing: "عرض",
      of: "من",
      results: "نتيجة",
      page: "صفحة",
      previous: "السابق",
      next: "التالي",
      tabs: {
        all: "جميع الطلبات",
        awaiting_payment: "في انتظار الدفع",
        paid_held: "مدفوع (محتجز)",
        processing: "قيد المعالجة",
        out_for_delivery: "في طريق التسليم",
        delivered: "تم التسليم",
        completed: "مكتمل",
        cancelled: "ملغي"
      },
      status: {
        awaiting_payment: "في انتظار الدفع",
        paid_held: "مدفوع (محتجز)",
        processing: "قيد المعالجة",
        out_for_delivery: "في طريق التسليم",
        dispatched: "تم الإرسال",
        delivered: "تم التسليم",
        completed: "مكتمل",
        cancelled: "تم إلغاء الطلب",
        accepted: "تم قبول الطلب",
        refunded: "تم الاسترداد",
        payment_released: "تم صرف الدفعة"
      },
      columns: {
        orderDetails: "تفاصيل الطلب",
        customer: "العميل",
        status: "الحالة",
        dates: "التواريخ",
        amount: "المبلغ",
        actions: "الإجراءات"
      }
    },
    orderDetails: {
      breadcrumb: { orders: "الطلبات" },
      orderId: "رقم الطلب",
      customerName: "اسم العميل",
      orderDate: "تاريخ الطلب",
      deliveredDate: "تاريخ التسليم",
      orderStatus: "حالة الطلب",
      totalAmount: "المبلغ الإجمالي",
      paymentMethod: "طريقة الدفع",
      deliveredAddress: "عنوان التسليم",
      quickActions: "إجراءات سريعة",
      downloadInvoice: "تنزيل الفاتورة",
      timeline: { title: "مراحل التوصيل" },
      escrow: { title: "الدفع محتجز في الضمان", heldBy: "محتجز لدى إنشاء" },
      contact: { title: "معلومات التواصل", supplier: "المورد", phone: "الهاتف", vehicle: "رقم المركبة" },
      deliveryProof: { title: "إثبات التسليم", cta: "رفع مستندات التسليم", hint: "الفاتورة، إشعار التسليم، الصور" },
      materials: {
        title: "المواد المطلوبة",
        serviceItems: "بنود الخدمة",
        unit: "الوحدة",
        qty: "الكمية",
        ratePerUnit: "السعر للوحدة",
        amount: "المبلغ (درهم)",
        notes: "ملاحظات",
        total: "الإجمالي"
      }
    }
  }
};
